import React from "react";
import SwiftIcon from "./SwiftIcon";
import { COLOR_VARS } from "../../../exports/ColorVars";

export const ICON_COLORS = COLOR_VARS;

export function BoxSearch({ color = ICON_COLORS["SWIFT_COLOR1"], size }) {
  const path = (
    <>
      <path d="M12.001 13.3C11.871 13.3 11.741 13.27 11.621 13.2L2.79099 8.08999C2.70554 8.04017 2.63076 7.97399 2.57093 7.89523C2.51109 7.81647 2.46738 7.72668 2.4423 7.631C2.41722 7.53533 2.41126 7.43564 2.42477 7.33766C2.43827 7.23967 2.47097 7.14531 2.52099 7.05999C2.57062 6.97434 2.6367 6.89936 2.71544 6.83938C2.79418 6.77939 2.88402 6.73559 2.97977 6.71049C3.07552 6.68539 3.17529 6.67949 3.27333 6.69313C3.37137 6.70678 3.46574 6.7397 3.55099 6.78999L12.001 11.68L20.401 6.81999C20.5738 6.72109 20.7786 6.69396 20.9712 6.74446C21.1638 6.79495 21.3289 6.91902 21.431 7.08999C21.641 7.44999 21.511 7.90999 21.161 8.11999L12.391 13.2C12.2697 13.2611 12.1367 13.2952 12.001 13.3Z" />
      <path d="M12 22.36C11.59 22.36 11.25 22.02 11.25 21.61V12.54C11.25 12.13 11.59 11.79 12 11.79C12.41 11.79 12.75 12.13 12.75 12.54V21.61C12.75 22.02 12.41 22.36 12 22.36Z" />
      <path d="M11.999 22.748C11.089 22.748 10.219 22.538 9.55903 22.168L4.21903 19.208C2.76903 18.408 1.62903 16.478 1.62903 14.818V9.15801C1.62903 7.49801 2.76903 5.57801 4.21903 4.76801L9.55903 1.80801C10.919 1.04801 13.059 1.04801 14.429 1.80801L19.769 4.76801C21.219 5.56801 22.359 7.49801 22.359 9.15801V12.818C22.359 13.228 22.019 13.568 21.609 13.568C21.199 13.568 20.859 13.228 20.859 12.818V9.15801C20.859 8.05801 20.009 6.61801 19.049 6.08801L13.709 3.12801C12.799 2.61801 11.209 2.61801 10.299 3.12801L4.95903 6.08801C3.98903 6.62801 3.14903 8.05801 3.14903 9.15801V14.818C3.14903 15.918 3.99903 17.358 4.95903 17.888L10.299 20.848C11.179 21.338 12.839 21.338 13.709 20.848C14.069 20.648 14.529 20.778 14.729 21.138C14.929 21.498 14.799 21.958 14.439 22.158C13.779 22.538 12.909 22.748 11.999 22.748Z" />
      <path d="M19.2 22.15C17.02 22.15 15.25 20.38 15.25 18.2C15.25 16.02 17.02 14.25 19.2 14.25C21.38 14.25 23.15 16.02 23.15 18.2C23.15 20.38 21.38 22.15 19.2 22.15ZM19.2 15.75C17.85 15.75 16.75 16.85 16.75 18.2C16.75 19.55 17.85 20.65 19.2 20.65C20.55 20.65 21.65 19.55 21.65 18.2C21.65 16.85 20.55 15.75 19.2 15.75Z" />
      <path d="M23.001 22.751C22.811 22.751 22.621 22.681 22.471 22.531L21.471 21.531C21.3318 21.3897 21.2537 21.1994 21.2537 21.001C21.2537 20.8027 21.3318 20.6123 21.471 20.471C21.761 20.181 22.241 20.181 22.531 20.471L23.531 21.471C23.821 21.761 23.821 22.241 23.531 22.531C23.381 22.681 23.191 22.751 23.001 22.751Z" />
    </>
  );

  return <SwiftIcon color={color} size={size} path={path} />;
}

export function Dashboard({ color = ICON_COLORS["SWIFT_COLOR1"], size }) {
  const path = (
    <>
      <path
        d="M9.5 18.9V3.1C9.5 1.6 8.86 1 7.27 1H3.23C1.64 1 1 1.6 1 3.1V18.9C1 20.4 1.64 21 3.23 21H7.27C8.86 21 9.5 20.4 9.5 18.9ZM21 9.9V3.1C21 1.6 20.36 1 18.77 1H14.73C13.14 1 12.5 1.6 12.5 3.1V9.9C12.5 11.4 13.14 12 14.73 12H18.77C20.36 12 21 11.4 21 9.9ZM21 18.9V17.1C21 15.6 20.36 15 18.77 15H14.73C13.14 15 12.5 15.6 12.5 17.1V18.9C12.5 20.4 13.14 21 14.73 21H18.77C20.36 21 21 20.4 21 18.9Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="transparent"
      />
    </>
  );

  return <SwiftIcon color={color} size={size} path={path} />;
}

export function Book({ color = ICON_COLORS["SWIFT_COLOR6"], size }) {
  const path = (
    <>
      <path
        d="M3.5 18V7C3.5 3 4.5 2 8.5 2H15.5C19.5 2 20.5 3 20.5 7V17C20.5 17.14 20.5 17.28 20.49 17.42"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="transparent"
      />
      <path
        d="M8 7H16M8 10.5H13M6.35 15H20.5V18.5C20.5 20.43 18.93 22 17 22H7C5.07 22 3.5 20.43 3.5 18.5V17.85C3.5 16.28 4.78 15 6.35 15Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="transparent"
      />
    </>
  );

  return <SwiftIcon color={color} size={size} path={path} />;
}

export function UserProfile({ color = ICON_COLORS["SWIFT_COLOR1"], size }) {
  const path = (
    <>
      <path d="M9.15899 11.62H9.07899C9.01941 11.61 8.95857 11.61 8.89899 11.62C5.99899 11.53 3.80899 9.25 3.80899 6.44C3.80899 3.58 6.13899 1.25 8.99899 1.25C11.859 1.25 14.189 3.58 14.189 6.44C14.179 9.25 11.979 11.53 9.18899 11.62H9.15899ZM8.99899 2.75C8.02115 2.75264 7.08412 3.14225 6.39268 3.83369C5.70124 4.52513 5.31163 5.46216 5.30899 6.44C5.30899 8.44 6.86899 10.05 8.85899 10.12C8.91899 10.11 9.04899 10.11 9.17899 10.12C11.139 10.03 12.679 8.42 12.689 6.44C12.6864 5.46216 12.2967 4.52513 11.6053 3.83369C10.9139 3.14225 9.97683 2.75264 8.99899 2.75ZM16.538 11.75C16.508 11.75 16.478 11.75 16.448 11.74C16.038 11.78 15.618 11.49 15.578 11.08C15.538 10.67 15.788 10.3 16.198 10.25C16.318 10.24 16.448 10.24 16.558 10.24C18.018 10.16 19.158 8.96 19.158 7.49C19.158 5.97 17.928 4.74 16.408 4.74C16.31 4.74132 16.2127 4.72316 16.1217 4.68657C16.0308 4.64997 15.948 4.59567 15.8783 4.52683C15.8085 4.45798 15.7531 4.37595 15.7153 4.28551C15.6774 4.19508 15.658 4.09803 15.658 4C15.658 3.59 15.998 3.25 16.408 3.25C17.5343 3.25264 18.6138 3.70126 19.4103 4.49771C20.2067 5.29417 20.6553 6.37364 20.658 7.5C20.658 9.8 18.858 11.66 16.568 11.75H16.538ZM9.17199 22.55C7.21199 22.55 5.24199 22.05 3.75199 21.05C2.36199 20.13 1.60199 18.87 1.60199 17.5C1.60199 16.13 2.36199 14.86 3.75199 13.93C6.75199 11.94 11.612 11.94 14.592 13.93C15.972 14.85 16.742 16.11 16.742 17.48C16.742 18.85 15.982 20.12 14.592 21.05C13.092 22.05 11.132 22.55 9.17199 22.55ZM4.58199 15.19C3.62199 15.83 3.10199 16.65 3.10199 17.51C3.10199 18.36 3.63199 19.18 4.58199 19.81C7.07199 21.48 11.272 21.48 13.762 19.81C14.722 19.17 15.242 18.35 15.242 17.49C15.242 16.64 14.712 15.82 13.762 15.19C11.272 13.53 7.07199 13.53 4.58199 15.19ZM18.338 20.75C17.988 20.75 17.678 20.51 17.608 20.15C17.5693 19.9553 17.6083 19.7532 17.7167 19.5868C17.8251 19.4205 17.9942 19.3032 18.188 19.26C18.818 19.13 19.398 18.88 19.848 18.53C20.418 18.1 20.728 17.56 20.728 16.99C20.728 16.42 20.418 15.88 19.858 15.46C19.418 15.12 18.868 14.88 18.218 14.73C18.0234 14.6856 17.8543 14.5661 17.7475 14.3975C17.6408 14.2289 17.605 14.0249 17.648 13.83C17.738 13.43 18.138 13.17 18.548 13.26C19.408 13.45 20.158 13.79 20.768 14.26C21.698 14.96 22.228 15.95 22.228 16.99C22.228 18.03 21.688 19.02 20.758 19.73C20.138 20.21 19.358 20.56 18.498 20.73C18.438 20.75 18.388 20.75 18.338 20.75Z" />
    </>
  );

  return <SwiftIcon color={color} size={size} path={path} />;
}

export function ArrangeHorizontal({
  color = ICON_COLORS["SWIFT_COLOR1"],
  size,
}) {
  const path = (
    <>
      <path d="M17.279 11.2C17.089 11.2 16.899 11.13 16.749 10.98C16.6095 10.8389 16.5313 10.6484 16.5313 10.45C16.5313 10.2516 16.6095 10.0612 16.749 9.92001L19.939 6.73001L16.749 3.54001C16.6095 3.39887 16.5313 3.20844 16.5313 3.01001C16.5313 2.81158 16.6095 2.62115 16.749 2.48001C17.039 2.19001 17.519 2.19001 17.809 2.48001L21.529 6.20001C21.6695 6.34064 21.7484 6.53126 21.7484 6.73001C21.7484 6.92876 21.6695 7.11939 21.529 7.26001L17.809 10.98C17.659 11.12 17.469 11.2 17.279 11.2Z" />
      <path d="M21 7.48001H3C2.59 7.48001 2.25 7.14001 2.25 6.73001C2.25 6.32001 2.59 5.98001 3 5.98001H21C21.41 5.98001 21.75 6.32001 21.75 6.73001C21.75 7.14001 21.41 7.48001 21 7.48001ZM6.72 21.75C6.53 21.75 6.34 21.68 6.19 21.53L2.47 17.81C2.32955 17.6694 2.25066 17.4788 2.25066 17.28C2.25066 17.0813 2.32955 16.8906 2.47 16.75L6.19 13.03C6.48 12.74 6.96 12.74 7.25 13.03C7.54 13.32 7.54 13.8 7.25 14.09L4.06 17.28L7.25 20.47C7.54 20.76 7.54 21.24 7.25 21.53C7.18183 21.6015 7.09948 21.6581 7.00822 21.6959C6.91695 21.7338 6.81879 21.7522 6.72 21.75Z" />
      <path d="M21 18.02H3C2.59 18.02 2.25 17.68 2.25 17.27C2.25 16.86 2.59 16.52 3 16.52H21C21.41 16.52 21.75 16.86 21.75 17.27C21.75 17.68 21.41 18.02 21 18.02Z" />
    </>
  );
  return <SwiftIcon color={color} size={size} path={path} />;
}

export function BriefCase({ color = ICON_COLORS["SWIFT_COLOR1"], size }) {
  const path = (
    <>
      <path d="M15.998 22.752H7.99803C3.37803 22.752 2.51803 20.602 2.29803 18.512L1.54803 10.502C1.43803 9.45199 1.40803 7.90199 2.44803 6.74199C3.34803 5.74199 4.83803 5.26199 6.99803 5.26199H16.998C19.168 5.26199 20.658 5.75199 21.548 6.74199C22.588 7.90199 22.558 9.45199 22.448 10.512L21.698 18.502C21.478 20.602 20.618 22.752 15.998 22.752ZM6.99803 6.75199C5.30803 6.75199 4.14803 7.08199 3.55803 7.74199C3.06803 8.28199 2.90803 9.11199 3.03803 10.352L3.78803 18.362C3.95803 19.942 4.38803 21.252 7.99803 21.252H15.998C19.598 21.252 20.038 19.942 20.208 18.352L20.958 10.362C21.088 9.11199 20.928 8.28199 20.438 7.74199C19.848 7.08199 18.688 6.75199 16.998 6.75199H6.99803Z" />
      <path d="M16 6.75C15.59 6.75 15.25 6.41 15.25 6V5.2C15.25 3.42 15.25 2.75 12.8 2.75H11.2C8.75 2.75 8.75 3.42 8.75 5.2V6C8.75 6.41 8.41 6.75 8 6.75C7.59 6.75 7.25 6.41 7.25 6V5.2C7.25 3.44 7.25 1.25 11.2 1.25H12.8C16.75 1.25 16.75 3.44 16.75 5.2V6C16.75 6.41 16.41 6.75 16 6.75ZM12 16.75C9.25 16.75 9.25 15.05 9.25 14.03V13C9.25 11.59 9.59 11.25 11 11.25H13C14.41 11.25 14.75 11.59 14.75 13V14C14.75 15.04 14.75 16.75 12 16.75ZM10.75 12.75V14.03C10.75 15.06 10.75 15.25 12 15.25C13.25 15.25 13.25 15.09 13.25 14.02V12.75H10.75Z" />
      <path d="M14 14.768C13.63 14.768 13.3 14.488 13.26 14.108C13.21 13.698 13.5 13.318 13.91 13.268C16.55 12.938 19.08 11.938 21.21 10.388C21.54 10.138 22.01 10.218 22.26 10.558C22.5 10.888 22.43 11.358 22.09 11.608C19.75 13.308 16.99 14.398 14.09 14.768H14ZM10 14.78H9.91001C7.17001 14.47 4.50001 13.47 2.19001 11.89C2.02646 11.7779 1.91373 11.6058 1.87628 11.4111C1.83884 11.2164 1.8797 11.0148 1.99001 10.85C2.22001 10.51 2.69001 10.42 3.03001 10.65C5.14001 12.09 7.57001 13 10.07 13.29C10.48 13.34 10.78 13.71 10.73 14.12C10.7 14.5 10.38 14.78 10 14.78Z" />
    </>
  );

  return <SwiftIcon color={color} size={size} path={path} />;
}

export function SecurityUser({ color = ICON_COLORS["SWIFT_COLOR1"], size }) {
  const path = (
    <>
      <path d="M12 22.76C10.91 22.76 9.83002 22.44 8.98002 21.81L4.68002 18.6C3.54002 17.75 2.65002 15.98 2.65002 14.56V7.13C2.65002 5.59 3.78002 3.95 5.23002 3.41L10.22 1.54C11.21 1.17 12.77 1.17 13.76 1.54L18.76 3.41C20.21 3.95 21.34 5.59 21.34 7.13V14.56C21.34 15.98 20.45 17.75 19.31 18.6L15.01 21.81C14.17 22.44 13.09 22.76 12 22.76ZM10.75 2.94L5.76002 4.81C4.90002 5.13 4.15002 6.21 4.15002 7.13V14.56C4.15002 15.51 4.82002 16.84 5.57002 17.4L9.87002 20.61C11.02 21.47 12.97 21.47 14.12 20.61L18.42 17.4C19.18 16.83 19.84 15.5 19.84 14.56V7.13C19.84 6.22 19.09 5.14 18.23 4.81L13.24 2.94C12.58 2.69 11.42 2.69 10.75 2.94Z" />
      <path d="M12 11.67H11.93C10.48 11.63 9.41999 10.52 9.41999 9.17C9.41999 7.79 10.55 6.66 11.93 6.66C13.31 6.66 14.44 7.79 14.44 9.17C14.4394 9.8201 14.187 10.4447 13.7358 10.9127C13.2846 11.3807 12.6696 11.6557 12.02 11.68C12.01 11.67 12.01 11.67 12 11.67ZM11.93 8.16C11.37 8.16 10.92 8.61 10.92 9.17C10.92 9.72 11.35 10.16 11.89 10.18H12C12.2564 10.1646 12.4971 10.0511 12.6721 9.86309C12.8471 9.67504 12.943 9.42687 12.94 9.17C12.9413 9.037 12.9161 8.90506 12.8658 8.78192C12.8155 8.65877 12.7412 8.5469 12.6471 8.45285C12.5531 8.35879 12.4412 8.28445 12.3181 8.23416C12.1949 8.18388 12.063 8.15867 11.93 8.16ZM12 17.35C11.14 17.35 10.27 17.12 9.59999 16.67C8.92999 16.23 8.54999 15.581 8.54999 14.891C8.54999 14.201 8.92999 13.551 9.59999 13.101C10.95 12.201 13.06 12.211 14.4 13.101C15.07 13.541 15.45 14.191 15.45 14.881C15.45 15.571 15.07 16.221 14.4 16.671C13.73 17.121 12.86 17.35 12 17.35ZM10.43 14.34C10.18 14.5 10.04 14.7 10.05 14.88C10.05 15.06 10.19 15.26 10.43 15.42C11.27 15.98 12.73 15.98 13.57 15.42C13.82 15.26 13.96 15.06 13.96 14.88C13.96 14.7 13.82 14.5 13.58 14.34C12.74 13.79 11.27 13.79 10.43 14.34Z" />
    </>
  );

  return <SwiftIcon color={color} size={size} path={path} />;
}

export function Wallet({ color = ICON_COLORS["SWIFT_COLOR1"], size }) {
  const path = (
    <>
      <path d="M17 22.75H7C3.56 22.75 1.25 20.44 1.25 17V12C1.25 8.92 3.15 6.69 6.1 6.32C6.38 6.28 6.69 6.25 7 6.25H17C17.24 6.25 17.55 6.26 17.87 6.31C20.82 6.65 22.75 8.89 22.75 12V17C22.75 20.44 20.44 22.75 17 22.75ZM7 7.75C6.76 7.75 6.53 7.77 6.3 7.8C4.1 8.08 2.75 9.68 2.75 12V17C2.75 19.58 4.42 21.25 7 21.25H17C19.58 21.25 21.25 19.58 21.25 17V12C21.25 9.66 19.88 8.05 17.66 7.79C17.42 7.75 17.21 7.75 17 7.75H7Z" />
      <path d="M6.192 7.81099C5.952 7.81099 5.732 7.70099 5.582 7.50099C5.49958 7.38982 5.45022 7.25763 5.4396 7.11964C5.42899 6.98165 5.45755 6.84347 5.522 6.72099C5.692 6.38099 5.932 6.05099 6.242 5.75099L9.492 2.49099C10.2933 1.69833 11.3749 1.25374 12.502 1.25374C13.6291 1.25374 14.7107 1.69833 15.512 2.49099L17.262 4.26099C18.002 4.99099 18.452 5.97099 18.502 7.01099C18.5076 7.12283 18.4881 7.2345 18.445 7.33785C18.4019 7.4412 18.3363 7.53363 18.2529 7.60837C18.1696 7.68312 18.0705 7.73831 17.9631 7.7699C17.8557 7.8015 17.7426 7.8087 17.632 7.79099C17.432 7.76099 17.222 7.75099 17.002 7.75099H7.002C6.762 7.75099 6.532 7.77099 6.302 7.80099C6.272 7.81099 6.232 7.81099 6.192 7.81099ZM7.862 6.25099H16.822C16.692 5.91099 16.482 5.60099 16.202 5.32099L14.442 3.54099C13.372 2.48099 11.622 2.48099 10.542 3.54099L7.862 6.25099ZM22 17.25H19C17.48 17.25 16.25 16.02 16.25 14.5C16.25 12.98 17.48 11.75 19 11.75H22C22.41 11.75 22.75 12.09 22.75 12.5C22.75 12.91 22.41 13.25 22 13.25H19C18.6685 13.25 18.3505 13.3817 18.1161 13.6161C17.8817 13.8505 17.75 14.1685 17.75 14.5C17.75 14.8315 17.8817 15.1495 18.1161 15.3839C18.3505 15.6183 18.6685 15.75 19 15.75H22C22.41 15.75 22.75 16.09 22.75 16.5C22.75 16.91 22.41 17.25 22 17.25Z" />
    </>
  );

  return <SwiftIcon color={color} size={size} path={path} />;
}

export function Add({ color = ICON_COLORS["SWIFT_COLOR1"], size }) {
  const path = (
    <>
      <path
        d="M18 12.75H6C5.59 12.75 5.25 12.41 5.25 12C5.25 11.59 5.59 11.25 6 11.25H18C18.41 11.25 18.75 11.59 18.75 12C18.75 12.41 18.41 12.75 18 12.75Z"
        fill={color}
      />
      <path
        d="M12 18.75C11.59 18.75 11.25 18.41 11.25 18V6C11.25 5.59 11.59 5.25 12 5.25C12.41 5.25 12.75 5.59 12.75 6V18C12.75 18.41 12.41 18.75 12 18.75Z"
        fill={color}
      />
    </>
  );

  return <SwiftIcon color={color} size={size} path={path} />;
}

export function AddSquare({ color = ICON_COLORS["SWIFT_COLOR1"], size }) {
  const path = (
    <>
      <path
        d="M16 12.75H8C7.59 12.75 7.25 12.41 7.25 12C7.25 11.59 7.59 11.25 8 11.25H16C16.41 11.25 16.75 11.59 16.75 12C16.75 12.41 16.41 12.75 16 12.75Z"
        fill={color}
      />
      <path
        d="M12 16.75C11.59 16.75 11.25 16.41 11.25 16V8C11.25 7.59 11.59 7.25 12 7.25C12.41 7.25 12.75 7.59 12.75 8V16C12.75 16.41 12.41 16.75 12 16.75Z"
        fill={color}
      />
      <path
        d="M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H15C20.43 1.25 22.75 3.57 22.75 9V15C22.75 20.43 20.43 22.75 15 22.75ZM9 2.75C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V9C21.25 4.39 19.61 2.75 15 2.75H9Z"
        fill={color}
      />
    </>
  );

  return <SwiftIcon color={color} size={size} path={path} />;
}
export function PatreonIcon({ color = ICON_COLORS["SWIFT_COLOR1"], size }) {
  const path = (
    <>
      <g
        id="social/logos/patreon"
        fill="none"
        fill-rule="evenodd"
        stroke="none"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
      >
        <path
          id="line"
          stroke={color}
          d="M11.5,1.5 C18.5,1.5 20.5,3.5 20.5,6.5 C20.5,12.5 15,11 12,13.5 C9,16 10.5,21.5 6.5,21.5 C3.5,21.5 2.5,15.5 2.5,10.5 C2.5,5.5 4.5,1.5 11.5,1.5 Z"
        ></path>
      </g>
    </>
  );

  return <SwiftIcon color={color} size={size} path={path} />;
}

export function ArchiveBook({ color = ICON_COLORS["SWIFT_COLOR1"], size }) {
  const path = (
    <>
      <path
        d="M16 22.75H8C4.35 22.75 2.25 20.65 2.25 17V7C2.25 3.35 4.35 1.25 8 1.25H16C19.65 1.25 21.75 3.35 21.75 7V17C21.75 20.65 19.65 22.75 16 22.75ZM8 2.75C5.14 2.75 3.75 4.14 3.75 7V17C3.75 19.86 5.14 21.25 8 21.25H16C18.86 21.25 20.25 19.86 20.25 17V7C20.25 4.14 18.86 2.75 16 2.75H8Z"
        fill={color}
      />
      <path
        d="M9 11.11C8.83647 11.1108 8.67438 11.0793 8.52302 11.0174C8.37166 10.9555 8.23399 10.8644 8.11789 10.7492C8.00179 10.634 7.90954 10.4971 7.84641 10.3462C7.78329 10.1954 7.75052 10.0335 7.75 9.87V2C7.75 1.59 8.09 1.25 8.5 1.25H15.5C15.91 1.25 16.25 1.59 16.25 2V9.86C16.25 10.36 15.96 10.81 15.5 11C15.05 11.2 14.52 11.11 14.15 10.77L12 8.8L9.85 10.78C9.61 11 9.31 11.11 9 11.11ZM12 7.21C12.3 7.21 12.61 7.32 12.85 7.54L14.75 9.29V2.75H9.25V9.29L11.15 7.54C11.39 7.32 11.7 7.21 12 7.21ZM17.5 14.75H13.25C12.84 14.75 12.5 14.41 12.5 14C12.5 13.59 12.84 13.25 13.25 13.25H17.5C17.91 13.25 18.25 13.59 18.25 14C18.25 14.41 17.91 14.75 17.5 14.75ZM17.5 18.75H9C8.59 18.75 8.25 18.41 8.25 18C8.25 17.59 8.59 17.25 9 17.25H17.5C17.91 17.25 18.25 17.59 18.25 18C18.25 18.41 17.91 18.75 17.5 18.75Z"
        fill={color}
      />
    </>
  );

  return <SwiftIcon color={color} size={size} path={path} />;
}

export function ArchiveTick({ color = ICON_COLORS["SWIFT_COLOR1"], size }) {
  const path = (
    <>
      <path
        d="M16.8199 2H7.17995C5.04995 2 3.31995 3.74 3.31995 5.86V19.95C3.31995 21.75 4.60995 22.51 6.18995 21.64L11.0699 18.93C11.5899 18.64 12.4299 18.64 12.9399 18.93L17.8199 21.64C19.3999 22.52 20.6899 21.76 20.6899 19.95V5.86C20.6799 3.74 18.9499 2 16.8199 2Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.58997 11L11.09 12.5L15.09 8.5"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  );

  return <SwiftIcon color={color} size={size} path={path} />;
}

export function MinusSquare({ color = ICON_COLORS["SWIFT_COLOR1"], size }) {
  const path = (
    <>
      <path
        d="M16 12.75H8C7.59 12.75 7.25 12.41 7.25 12C7.25 11.59 7.59 11.25 8 11.25H16C16.41 11.25 16.75 11.59 16.75 12C16.75 12.41 16.41 12.75 16 12.75Z"
        fill={color}
      />
      <path
        d="M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H15C20.43 1.25 22.75 3.57 22.75 9V15C22.75 20.43 20.43 22.75 15 22.75ZM9 2.75C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V9C21.25 4.39 19.61 2.75 15 2.75H9Z"
        fill={color}
      />
    </>
  );

  return <SwiftIcon color={color} size={size} path={path} />;
}

export function UserSearch({ color = ICON_COLORS["SWIFT_COLOR1"], size }) {
  const path = (
    <>
      <path
        d="M12 12.75C8.82997 12.75 6.24997 10.17 6.24997 7C6.24997 3.83 8.82997 1.25 12 1.25C15.17 1.25 17.75 3.83 17.75 7C17.75 10.17 15.17 12.75 12 12.75ZM12 2.75C10.8736 2.75264 9.79414 3.20126 8.99769 3.99771C8.20123 4.79417 7.75261 5.87364 7.74997 7C7.75261 8.12636 8.20123 9.20583 8.99769 10.0023C9.79414 10.7987 10.8736 11.2474 12 11.25C13.1263 11.2474 14.2058 10.7987 15.0023 10.0023C15.7987 9.20583 16.2473 8.12636 16.25 7C16.2473 5.87364 15.7987 4.79417 15.0023 3.99771C14.2058 3.20126 13.1263 2.75264 12 2.75ZM3.40997 22.75C2.99997 22.75 2.65997 22.41 2.65997 22C2.65997 17.73 6.84997 14.25 12 14.25C12.41 14.25 12.75 14.59 12.75 15C12.75 15.41 12.41 15.75 12 15.75C7.67997 15.75 4.15997 18.55 4.15997 22C4.15997 22.41 3.81997 22.75 3.40997 22.75ZM18.2 22.15C16.02 22.15 14.25 20.38 14.25 18.2C14.25 16.02 16.02 14.25 18.2 14.25C20.38 14.25 22.15 16.02 22.15 18.2C22.15 20.38 20.38 22.15 18.2 22.15ZM18.2 15.75C16.85 15.75 15.75 16.85 15.75 18.2C15.75 19.55 16.85 20.65 18.2 20.65C19.55 20.65 20.65 19.55 20.65 18.2C20.65 16.85 19.55 15.75 18.2 15.75Z"
        fill={color}
      />
      <path
        d="M22.001 22.751C21.811 22.751 21.621 22.681 21.471 22.531L20.471 21.531C20.3318 21.3897 20.2537 21.1993 20.2537 21.001C20.2537 20.8026 20.3318 20.6122 20.471 20.471C20.761 20.181 21.241 20.181 21.531 20.471L22.531 21.471C22.821 21.761 22.821 22.241 22.531 22.531C22.381 22.681 22.191 22.751 22.001 22.751Z"
        fill={color}
      />
    </>
  );

  return <SwiftIcon color={color} size={size} path={path} />;
}

export function User({ color = ICON_COLORS["SWIFT_COLOR1"], size }) {
  const path = (
    <>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color={color} fill="none" stroke={color}stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="12" cy="7" r="4"></circle>
        <path d="M12 14C7 14 4 16.5 4 19C4 20.1046 4.89543 21 6 21H18C19.1046 21 20 20.1046 20 19C20 16.5 17 14 12 14Z"></path>
      </svg>
    </>
  );

  return <SwiftIcon color={color} size={size} path={path} />;
}

export function Calculator({ color = ICON_COLORS["SWIFT_COLOR1"], size }) {
  const path = (
    <>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color={color} fill="none" stroke={color} stroke-width="1.5">
    <path d="M3 10H21" stroke-linejoin="round"></path>
    <path d="M15 6L17 6" stroke-linecap="round" stroke-linejoin="round"></path>
    <path d="M21 13V11C21 6.75736 21 4.63604 19.682 3.31802C18.364 2 16.2426 2 12 2C7.75736 2 5.63604 2 4.31802 3.31802C3 4.63604 3 6.75736 3 11V13C3 17.2426 3 19.364 4.31802 20.682C5.63604 22 7.75736 22 12 22C16.2426 22 18.364 22 19.682 20.682C21 19.364 21 17.2426 21 13Z"></path>
    <path d="M7 14H7.52632M11.7368 14H12.2632M16.4737 14H17" stroke-linecap="round" stroke-linejoin="round"></path>
    <path d="M7 18H7.52632M11.7368 18H12.2632M16.4737 18H17" stroke-linecap="round" stroke-linejoin="round"></path>
</svg>
    </>
  );

  return <SwiftIcon color={color} size={size} path={path} />;
}

export function Duplicate({ color = ICON_COLORS["SWIFT_COLOR1"], size }) {
  const path = (
    <>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color={color} fill="none" stroke={color} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
    <path d="M7 11V9C7 5.70017 7 4.05025 8.02513 3.02513C9.05025 2 10.7002 2 14 2C17.2998 2 18.9497 2 19.9749 3.02513C21 4.05025 21 5.70017 21 9V11C21 14.2998 21 15.9497 19.9749 16.9749C18.9497 18 17.2998 18 14 18C10.7002 18 9.05025 18 8.02513 16.9749C7 15.9497 7 14.2998 7 11Z"></path>
    <path d="M3 6V15C3 18.2998 3 19.9497 4.02513 20.9749C5.05025 22 6.70017 22 10 22H17"></path>
</svg>
    </>
  );

  return <SwiftIcon color={color} size={size} path={path} />;
}

export function Json({ color = ICON_COLORS["SWIFT_COLOR1"], size }) {
  const path = (
    <>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color={color} fill="none" stroke={color} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
    <path d="M18 21C19.2322 21 20.231 19.8487 20.231 18.4286C20.231 16.1808 20.1312 14.6865 21.6733 12.9091C22.1089 12.407 22.1089 11.593 21.6733 11.0909C20.1312 9.31354 20.231 7.81916 20.231 5.57143C20.231 4.15127 19.2322 3 18 3"></path>
    <path d="M6 21C4.76784 21 3.76897 19.8487 3.76897 18.4286C3.76897 16.1808 3.86877 14.6865 2.32673 12.9091C1.89109 12.407 1.89109 11.593 2.32673 11.0909C3.83496 9.35251 3.76897 7.83992 3.76897 5.57143C3.76897 4.15127 4.76784 3 6 3"></path>
</svg>
    </>
  );

  return <SwiftIcon color={color} size={size} path={path} />;
}

export function WalletMoney({ color = ICON_COLORS["SWIFT_COLOR1"], size }) {
  const path = (
    <>
      <path
        d="M7.17003 22.752C4.79003 22.752 2.84003 21.022 2.84003 18.892V16.852C2.84003 16.442 3.18003 16.102 3.59003 16.102C4.00003 16.102 4.34003 16.442 4.34003 16.852C4.34003 18.102 5.55003 19.042 7.17003 19.042C8.79003 19.042 10 18.102 10 16.852C10 16.442 10.34 16.102 10.75 16.102C11.16 16.102 11.5 16.442 11.5 16.852V18.892C11.5 21.022 9.56003 22.752 7.17003 22.752ZM4.60003 19.872C5.04003 20.692 6.03003 21.252 7.17003 21.252C8.31003 21.252 9.30003 20.682 9.74003 19.872C9.03003 20.302 8.15003 20.552 7.17003 20.552C6.19003 20.552 5.31003 20.302 4.60003 19.872Z"
        fill={color}
      />
      <path
        d="M7.17003 17.801C5.53003 17.801 4.06003 17.051 3.33003 15.861C3.01003 15.341 2.84003 14.731 2.84003 14.111C2.84003 13.061 3.30003 12.081 4.14003 11.351C5.76003 9.93098 8.55003 9.93098 10.18 11.341C11.02 12.081 11.49 13.061 11.49 14.111C11.49 14.731 11.32 15.341 11 15.861C10.28 17.051 8.81003 17.801 7.17003 17.801ZM7.17003 11.751C6.39003 11.751 5.67003 12.011 5.13003 12.481C4.62003 12.921 4.34003 13.501 4.34003 14.111C4.34003 14.461 4.43003 14.781 4.61003 15.081C5.07003 15.841 6.05003 16.311 7.17003 16.311C8.29003 16.311 9.27003 15.841 9.72003 15.091C9.90003 14.801 9.99003 14.471 9.99003 14.121C9.99003 13.511 9.71003 12.931 9.20003 12.481C8.67003 12.011 7.95003 11.751 7.17003 11.751Z"
        fill={color}
      />
      <path
        d="M7.17003 20.55C4.70003 20.55 2.84003 18.96 2.84003 16.86V14.11C2.84003 11.98 4.78003 10.25 7.17003 10.25C8.30003 10.25 9.38003 10.64 10.19 11.34C11.03 12.08 11.5 13.06 11.5 14.11V16.86C11.5 18.96 9.64003 20.55 7.17003 20.55ZM7.17003 11.75C5.61003 11.75 4.34003 12.81 4.34003 14.11V16.86C4.34003 18.11 5.55003 19.05 7.17003 19.05C8.79003 19.05 10 18.11 10 16.86V14.11C10 13.5 9.72003 12.92 9.21003 12.47C8.67003 12.01 7.95003 11.75 7.17003 11.75ZM19.04 14.8C17.53 14.8 16.25 13.68 16.13 12.24C16.05 11.41 16.35 10.6 16.95 10.01C17.45 9.49001 18.16 9.20001 18.91 9.20001H21C21.99 9.23001 22.75 10.01 22.75 10.97V13.03C22.75 13.99 21.99 14.77 21.03 14.8H19.04ZM20.97 10.7H18.92C18.57 10.7 18.25 10.83 18.02 11.07C17.73 11.35 17.59 11.73 17.63 12.11C17.68 12.77 18.32 13.3 19.04 13.3H21C21.13 13.3 21.25 13.18 21.25 13.03V10.97C21.25 10.82 21.13 10.71 20.97 10.7Z"
        fill={color}
      />
      <path
        d="M16.002 21.25H13.502C13.092 21.25 12.752 20.91 12.752 20.5C12.752 20.09 13.092 19.75 13.502 19.75H16.002C18.582 19.75 20.252 18.08 20.252 15.5V14.8H19.042C17.532 14.8 16.252 13.68 16.132 12.24C16.052 11.41 16.352 10.6 16.952 10.01C17.452 9.49 18.162 9.2 18.912 9.2H20.242V8.5C20.242 6.16 18.872 4.55 16.652 4.29C16.412 4.25 16.202 4.25 15.992 4.25H6.992C6.752 4.25 6.522 4.27 6.292 4.3C4.092 4.58 2.742 6.18 2.742 8.5V10.5C2.742 10.91 2.402 11.25 1.992 11.25C1.582 11.25 1.242 10.91 1.242 10.5V8.5C1.242 5.42 3.142 3.19 6.092 2.82C6.362 2.78 6.672 2.75 6.992 2.75H15.992C16.232 2.75 16.542 2.76 16.862 2.81C19.812 3.15 21.742 5.39 21.742 8.5V9.95C21.742 10.36 21.402 10.7 20.992 10.7H18.912C18.562 10.7 18.242 10.83 18.012 11.07C17.722 11.35 17.582 11.73 17.622 12.11C17.672 12.77 18.312 13.3 19.032 13.3H21.002C21.412 13.3 21.752 13.64 21.752 14.05V15.5C21.752 18.94 19.442 21.25 16.002 21.25Z"
        fill={color}
      />
    </>
  );

  return <SwiftIcon color={color} size={size} path={path} />;
}

export function DocumentText({ color = ICON_COLORS["SWIFT_COLOR1"], size }) {
  const path = (
    <>
      <path
        d="M16 22.75H8C4.35 22.75 2.25 20.65 2.25 17V7C2.25 3.35 4.35 1.25 8 1.25H16C19.65 1.25 21.75 3.35 21.75 7V17C21.75 20.65 19.65 22.75 16 22.75ZM8 2.75C5.14 2.75 3.75 4.14 3.75 7V17C3.75 19.86 5.14 21.25 8 21.25H16C18.86 21.25 20.25 19.86 20.25 17V7C20.25 4.14 18.86 2.75 16 2.75H8Z"
        fill={color}
      />
      <path
        d="M18.5 9.25H16.5C14.98 9.25 13.75 8.02 13.75 6.5V4.5C13.75 4.09 14.09 3.75 14.5 3.75C14.91 3.75 15.25 4.09 15.25 4.5V6.5C15.25 7.19 15.81 7.75 16.5 7.75H18.5C18.91 7.75 19.25 8.09 19.25 8.5C19.25 8.91 18.91 9.25 18.5 9.25ZM12 13.75H8C7.59 13.75 7.25 13.41 7.25 13C7.25 12.59 7.59 12.25 8 12.25H12C12.41 12.25 12.75 12.59 12.75 13C12.75 13.41 12.41 13.75 12 13.75ZM16 17.75H8C7.59 17.75 7.25 17.41 7.25 17C7.25 16.59 7.59 16.25 8 16.25H16C16.41 16.25 16.75 16.59 16.75 17C16.75 17.41 16.41 17.75 16 17.75Z"
        fill={color}
      />
    </>
  );

  return <SwiftIcon color={color} size={size} path={path} />;
}

export function Link({ color = ICON_COLORS["SWIFT_COLOR1"], size }) {
  const path = (
    <>
      <path
        d="M7.75 18.5C4.17 18.5 1.25 15.58 1.25 12C1.25 8.42 4.17 5.5 7.75 5.5C8.16 5.5 8.5 5.84 8.5 6.25C8.5 6.66 8.16 7 7.75 7C4.99 7 2.75 9.24 2.75 12C2.75 14.76 4.99 17 7.75 17C10.51 17 12.75 14.76 12.75 12C12.75 11.59 13.09 11.25 13.5 11.25C13.91 11.25 14.25 11.59 14.25 12C14.25 15.58 11.33 18.5 7.75 18.5Z"
        fill={color}
      />
      <path
        d="M16 18.75C15.59 18.75 15.25 18.41 15.25 18C15.25 17.59 15.59 17.25 16 17.25C18.89 17.25 21.25 14.89 21.25 12C21.25 9.11 18.89 6.75 16 6.75C13.11 6.75 10.75 9.11 10.75 12C10.75 12.41 10.41 12.75 10 12.75C9.59 12.75 9.25 12.41 9.25 12C9.25 8.28 12.28 5.25 16 5.25C19.72 5.25 22.75 8.28 22.75 12C22.75 15.72 19.72 18.75 16 18.75Z"
        fill={color}
      />
    </>
  );

  return <SwiftIcon color={color} size={size} path={path} />;
}

export function Link2({ color = ICON_COLORS["SWIFT_COLOR1"], size }) {
  const path = (
    <>
      <path
        d="M8.98993 21.501C7.32993 21.501 5.65993 20.871 4.38993 19.601C1.85993 17.061 1.85993 12.941 4.38993 10.411C4.67993 10.121 5.15993 10.121 5.44993 10.411C5.73993 10.701 5.73993 11.181 5.44993 11.471C4.51331 12.409 3.98724 13.6804 3.98724 15.006C3.98724 16.3316 4.51331 17.603 5.44993 18.541C6.38796 19.4776 7.65935 20.0037 8.98493 20.0037C10.3105 20.0037 11.5819 19.4776 12.5199 18.541C13.4599 17.601 13.9799 16.341 13.9799 15.001C13.9799 13.671 13.4599 12.411 12.5199 11.461C12.3805 11.3199 12.3022 11.1294 12.3022 10.931C12.3022 10.7326 12.3805 10.5421 12.5199 10.401C12.8099 10.111 13.2899 10.111 13.5799 10.401C14.1855 11.0037 14.6653 11.7207 14.9915 12.5104C15.3176 13.3 15.4837 14.1466 15.4799 15.001C15.4799 16.741 14.7999 18.371 13.5799 19.601C12.979 20.2062 12.2638 20.6858 11.4758 21.012C10.6878 21.3382 9.84277 21.5044 8.98993 21.501Z"
        fill={color}
      />
      <path
        d="M19.0679 14.158C18.8779 14.158 18.6879 14.088 18.5379 13.938C18.3984 13.7969 18.3202 13.6064 18.3202 13.408C18.3202 13.2096 18.3984 13.0191 18.5379 12.878C20.5879 10.828 20.5879 7.49801 18.5379 5.45801C16.4879 3.40801 13.1579 3.40801 11.1179 5.45801C10.6289 5.94406 10.2411 6.52217 9.97673 7.15894C9.71241 7.79572 9.57685 8.47855 9.57788 9.16801C9.57788 10.568 10.1279 11.888 11.1179 12.878C11.4079 13.168 11.4079 13.648 11.1179 13.938C10.8279 14.228 10.3479 14.228 10.0579 13.938C9.42953 13.3128 8.93109 12.5695 8.59127 11.7508C8.25145 10.9322 8.07697 10.0544 8.07788 9.16801C8.07788 7.36801 8.77788 5.66801 10.0579 4.39801C12.6879 1.76801 16.9679 1.76801 19.6079 4.39801C22.2379 7.02801 22.2379 11.318 19.6079 13.948C19.4579 14.088 19.2579 14.158 19.0679 14.158Z"
        fill={color}
      />
    </>
  );

  return <SwiftIcon color={color} size={size} path={path} />;
}

export function Verify({ color = ICON_COLORS["SWIFT_COLOR1"], size }) {
  const path = (
    <>
      <path
        d="M21.5599 10.739L20.1999 9.15901C19.9399 8.85901 19.7299 8.29901 19.7299 7.89901V6.19901C19.7299 5.13901 18.8599 4.26901 17.7999 4.26901H16.0999C15.7099 4.26901 15.1399 4.05901 14.8399 3.79901L13.2599 2.43901C12.5699 1.84901 11.4399 1.84901 10.7399 2.43901L9.16988 3.80901C8.86988 4.05901 8.29988 4.26901 7.90988 4.26901H6.17988C5.11988 4.26901 4.24988 5.13901 4.24988 6.19901V7.90901C4.24988 8.29901 4.03988 8.85901 3.78988 9.15901L2.43988 10.749C1.85988 11.439 1.85988 12.559 2.43988 13.249L3.78988 14.839C4.03988 15.139 4.24988 15.699 4.24988 16.089V17.799C4.24988 18.859 5.11988 19.729 6.17988 19.729H7.90988C8.29988 19.729 8.86988 19.939 9.16988 20.199L10.7499 21.559C11.4399 22.149 12.5699 22.149 13.2699 21.559L14.8499 20.199C15.1499 19.939 15.7099 19.729 16.1099 19.729H17.8099C18.8699 19.729 19.7399 18.859 19.7399 17.799V16.099C19.7399 15.709 19.9499 15.139 20.2099 14.839L21.5699 13.259C22.1499 12.569 22.1499 11.429 21.5599 10.739ZM16.1599 10.109L11.3299 14.939C11.1893 15.0795 10.9986 15.1583 10.7999 15.1583C10.6011 15.1583 10.4105 15.0795 10.2699 14.939L7.84988 12.519C7.7104 12.3779 7.63218 12.1874 7.63218 11.989C7.63218 11.7906 7.7104 11.6001 7.84988 11.459C8.13988 11.169 8.61988 11.169 8.90988 11.459L10.7999 13.349L15.0999 9.04901C15.3899 8.75901 15.8699 8.75901 16.1599 9.04901C16.4499 9.33901 16.4499 9.81901 16.1599 10.109Z"
        fill={color}
      />
    </>
  );

  return <SwiftIcon color={color} size={size} path={path} />;
}

export function LinkPair({ color = ICON_COLORS["SWIFT_COLOR1"], size }) {
  const path = (
    <>
      <path
        d="M12.502 14.75H10.002C9.592 14.75 9.252 14.41 9.252 14C9.252 13.59 9.592 13.25 10.002 13.25H12.502C15.122 13.25 17.252 11.12 17.252 8.5C17.252 5.88 15.122 3.75 12.502 3.75H7.502C4.882 3.75 2.752 5.88 2.752 8.5C2.752 9.6 3.142 10.67 3.842 11.52C4.102 11.84 4.062 12.31 3.742 12.58C3.422 12.84 2.952 12.8 2.682 12.48C1.7527 11.3618 1.24334 9.95397 1.242 8.5C1.242 5.05 4.042 2.25 7.492 2.25H12.492C15.942 2.25 18.742 5.05 18.742 8.5C18.742 11.95 15.952 14.75 12.502 14.75Z"
        fill={color}
      />
      <path
        d="M16.5 21.75H11.5C8.05 21.75 5.25 18.95 5.25 15.5C5.25 12.05 8.05 9.25 11.5 9.25H14C14.41 9.25 14.75 9.59 14.75 10C14.75 10.41 14.41 10.75 14 10.75H11.5C8.88 10.75 6.75 12.88 6.75 15.5C6.75 18.12 8.88 20.25 11.5 20.25H16.5C19.12 20.25 21.25 18.12 21.25 15.5C21.25 14.4 20.86 13.33 20.16 12.48C20.034 12.3256 19.9738 12.1279 19.9926 11.9295C20.0113 11.7311 20.1074 11.5481 20.26 11.42C20.336 11.3566 20.4238 11.3089 20.5183 11.2796C20.6129 11.2503 20.7123 11.24 20.8108 11.2493C20.9094 11.2586 21.0051 11.2873 21.0925 11.3337C21.1799 11.3802 21.2572 11.4435 21.32 11.52C22.2493 12.6382 22.7587 14.046 22.76 15.5C22.75 18.95 19.95 21.75 16.5 21.75Z"
        fill={color}
      />
    </>
  );

  return <SwiftIcon color={color} size={size} path={path} />;
}

export function LinkDash({ color = ICON_COLORS["SWIFT_COLOR1"], size }) {
  const path = (
    <>
      <path
        d="M16.498 18.25H14.988C14.578 18.25 14.238 17.91 14.238 17.5C14.238 17.09 14.578 16.75 14.988 16.75H16.498C19.118 16.75 21.248 14.62 21.248 12C21.248 9.38 19.118 7.25 16.498 7.25H14.998C14.7991 7.25 14.6083 7.17098 14.4677 7.03033C14.327 6.88968 14.248 6.69891 14.248 6.5C14.248 6.30109 14.327 6.11032 14.4677 5.96967C14.6083 5.82902 14.7991 5.75 14.998 5.75H16.498C19.948 5.75 22.748 8.55 22.748 12C22.748 15.45 19.948 18.25 16.498 18.25ZM9 18.25H7.5C4.05 18.25 1.25 15.45 1.25 12C1.25 8.55 4.05 5.75 7.5 5.75H9C9.41 5.75 9.75 6.09 9.75 6.5C9.75 6.91 9.41 7.25 9 7.25H7.5C4.88 7.25 2.75 9.38 2.75 12C2.75 14.62 4.88 16.75 7.5 16.75H9C9.41 16.75 9.75 17.09 9.75 17.5C9.75 17.91 9.41 18.25 9 18.25Z"
        fill={color}
      />
      <path
        d="M16 12.75H8C7.59 12.75 7.25 12.41 7.25 12C7.25 11.59 7.59 11.25 8 11.25H16C16.41 11.25 16.75 11.59 16.75 12C16.75 12.41 16.41 12.75 16 12.75Z"
        fill={color}
      />
    </>
  );

  return <SwiftIcon color={color} size={size} path={path} />;
}

export function FilterSearch({ color = ICON_COLORS["SWIFT_COLOR1"], size }) {
  const path = (
    <>
      <path
        d="M14.32 19.07C14.32 19.68 13.92 20.48 13.41 20.79L12 21.7C10.69 22.51 8.87 21.6 8.87 19.98V14.63C8.87 13.92 8.47 13.01 8.06 12.51L4.22 8.47001C3.71 7.96001 3.31 7.06001 3.31 6.45001V4.13001C3.31 2.92001 4.22 2.01001 5.33 2.01001H18.67C19.78 2.01001 20.69 2.92001 20.69 4.03001V6.25001C20.69 7.06001 20.18 8.07001 19.68 8.57001"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.87 17.12L18.87 16.12M16.07 16.52C16.9187 16.52 17.7326 16.1829 18.3327 15.5827C18.9329 14.9826 19.27 14.1687 19.27 13.32C19.27 12.4713 18.9329 11.6574 18.3327 11.0573C17.7326 10.4571 16.9187 10.12 16.07 10.12C15.2213 10.12 14.4074 10.4571 13.8073 11.0573C13.2071 11.6574 12.87 12.4713 12.87 13.32C12.87 14.1687 13.2071 14.9826 13.8073 15.5827C14.4074 16.1829 15.2213 16.52 16.07 16.52Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  );

  return <SwiftIcon color="none" size={size} path={path} />;
}

export function ReceiptEdit({ color = ICON_COLORS["SWIFT_COLOR1"], size }) {
  const path = (
    <>
      <path
        d="M10.54 21.94C10.31 21.94 10.09 21.84 9.93999 21.64L8.92999 20.29C8.71999 20.01 8.43999 19.85 8.13999 19.83C7.82999 19.81 7.53999 19.95 7.29999 20.2C5.84999 21.75 4.74999 21.62 4.21999 21.42C3.67999 21.21 2.76999 20.52 2.76999 18.3V7.04C2.76999 2.6 4.04999 1.25 8.23999 1.25H15.79C19.98 1.25 21.26 2.6 21.26 7.04V11.3C21.26 11.71 20.92 12.05 20.51 12.05C20.1 12.05 19.76 11.71 19.76 11.3V7.04C19.76 3.43 19.13 2.75 15.79 2.75H8.23999C4.89999 2.75 4.26999 3.43 4.26999 7.04V18.3C4.26999 19.35 4.52999 19.93 4.76999 20.02C4.94999 20.09 5.43999 19.99 6.19999 19.18C6.74999 18.6 7.46999 18.29 8.21999 18.33C8.95999 18.37 9.65999 18.76 10.13 19.39L11.15 20.74C11.2341 20.8521 11.2851 20.9855 11.2972 21.1252C11.3094 21.2648 11.2821 21.405 11.2186 21.5299C11.1551 21.6549 11.0579 21.7595 10.9379 21.832C10.818 21.9045 10.6801 21.9419 10.54 21.94Z"
        fill={color}
      />
      <path
        d="M16 7.75H8C7.59 7.75 7.25 7.41 7.25 7C7.25 6.59 7.59 6.25 8 6.25H16C16.41 6.25 16.75 6.59 16.75 7C16.75 7.41 16.41 7.75 16 7.75ZM15 11.75H9C8.59 11.75 8.25 11.41 8.25 11C8.25 10.59 8.59 10.25 9 10.25H15C15.41 10.25 15.75 10.59 15.75 11C15.75 11.41 15.41 11.75 15 11.75ZM14.82 21.782C14.44 21.782 14.08 21.642 13.82 21.382C13.51 21.072 13.37 20.622 13.44 20.152L13.63 18.802C13.68 18.452 13.89 18.032 14.14 17.782L17.68 14.242C18.16 13.762 18.63 13.512 19.14 13.462C19.76 13.402 20.38 13.662 20.96 14.242C21.54 14.822 21.8 15.432 21.74 16.062C21.69 16.562 21.43 17.042 20.96 17.522L17.42 21.062C17.17 21.312 16.75 21.522 16.4 21.572L15.05 21.762C14.97 21.772 14.9 21.782 14.82 21.782ZM19.31 14.952H19.28C19.14 14.962 18.95 15.092 18.74 15.302L15.2 18.842C15.1595 18.8911 15.132 18.9495 15.12 19.012L14.94 20.262L16.19 20.082C16.23 20.072 16.33 20.022 16.36 19.992L19.9 16.452C20.11 16.232 20.24 16.052 20.25 15.912C20.27 15.712 20.07 15.472 19.9 15.302C19.74 15.142 19.51 14.952 19.31 14.952Z"
        fill={color}
      />
      <path
        d="M19.92 18.25C19.85 18.25 19.78 18.24 19.72 18.22C19.0675 18.0348 18.4733 17.6858 17.9937 17.2063C17.5141 16.7267 17.1652 16.1324 16.98 15.48C16.9274 15.2877 16.9525 15.0825 17.0497 14.9086C17.147 14.7346 17.3087 14.6059 17.5 14.55C17.9 14.44 18.31 14.67 18.42 15.07C18.65 15.89 19.3 16.54 20.12 16.77C20.2937 16.8204 20.4436 16.9316 20.5423 17.0832C20.641 17.2348 20.682 17.4169 20.6577 17.5962C20.6335 17.7755 20.5457 17.9401 20.4103 18.0601C20.2749 18.1801 20.1009 18.2475 19.92 18.25Z"
        fill={color}
      />
    </>
  );

  return <SwiftIcon color="none" size={size} path={path} />;
}

export function Edit({ color = ICON_COLORS["SWIFT_COLOR1"], size }) {
  const path = (
    <>
      <path
        d="M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H11C11.41 1.25 11.75 1.59 11.75 2C11.75 2.41 11.41 2.75 11 2.75H9C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V13C21.25 12.59 21.59 12.25 22 12.25C22.41 12.25 22.75 12.59 22.75 13V15C22.75 20.43 20.43 22.75 15 22.75Z"
        fill={color}
      />
      <path
        d="M8.49999 17.689C7.88999 17.689 7.32999 17.469 6.91999 17.069C6.42999 16.579 6.21999 15.869 6.32999 15.119L6.75999 12.109C6.83999 11.529 7.21999 10.779 7.62999 10.369L15.51 2.48902C17.5 0.499021 19.52 0.499021 21.51 2.48902C22.6 3.57902 23.09 4.68902 22.99 5.79902C22.9 6.69902 22.42 7.57902 21.51 8.47902L13.63 16.359C13.22 16.769 12.47 17.149 11.89 17.229L8.87999 17.659C8.74999 17.689 8.61999 17.689 8.49999 17.689ZM16.57 3.54902L8.68999 11.429C8.49999 11.619 8.27999 12.059 8.23999 12.319L7.80999 15.329C7.76999 15.619 7.82999 15.859 7.97999 16.009C8.12999 16.159 8.36999 16.219 8.65999 16.179L11.67 15.749C11.93 15.709 12.38 15.489 12.56 15.299L20.44 7.41902C21.09 6.76902 21.43 6.18902 21.48 5.64902C21.54 4.99902 21.2 4.30902 20.44 3.53902C18.84 1.93902 17.74 2.38902 16.57 3.54902Z"
        fill={color}
      />
      <path
        d="M19.85 9.83003C19.78 9.83003 19.71 9.82003 19.65 9.80003C18.3504 9.42998 17.1668 8.73425 16.2113 7.77875C15.2558 6.82326 14.5601 5.63964 14.19 4.34003C14.1374 4.14779 14.1625 3.94259 14.2597 3.76864C14.357 3.59469 14.5187 3.4659 14.71 3.41003C15.11 3.30003 15.52 3.53003 15.63 3.93003C16.23 6.06003 17.92 7.75003 20.05 8.35003C20.45 8.46003 20.68 8.88003 20.57 9.28003C20.48 9.62003 20.18 9.83003 19.85 9.83003Z"
        fill={color}
      />
    </>
  );

  return <SwiftIcon color="none" size={size} path={path} />;
}

export function BarCode({ color = ICON_COLORS["SWIFT_COLOR1"], size }) {
  const path = (
    <>
      <path
        d="M17 21.25H7C3.35 21.25 1.25 19.15 1.25 15.5V8.5C1.25 4.85 3.35 2.75 7 2.75H17C20.65 2.75 22.75 4.85 22.75 8.5V15.5C22.75 19.15 20.65 21.25 17 21.25ZM7 4.25C4.14 4.25 2.75 5.64 2.75 8.5V15.5C2.75 18.36 4.14 19.75 7 19.75H17C19.86 19.75 21.25 18.36 21.25 15.5V8.5C21.25 5.64 19.86 4.25 17 4.25H7Z"
        fill={color}
      />
      <path
        d="M6 16.75C5.59 16.75 5.25 16.41 5.25 16V8C5.25 7.59 5.59 7.25 6 7.25C6.41 7.25 6.75 7.59 6.75 8V16C6.75 16.41 6.41 16.75 6 16.75ZM9 12.75C8.59 12.75 8.25 12.41 8.25 12V8C8.25 7.59 8.59 7.25 9 7.25C9.41 7.25 9.75 7.59 9.75 8V12C9.75 12.41 9.41 12.75 9 12.75ZM9 16.75C8.59 16.75 8.25 16.41 8.25 16V15C8.25 14.59 8.59 14.25 9 14.25C9.41 14.25 9.75 14.59 9.75 15V16C9.75 16.41 9.41 16.75 9 16.75ZM15 9.75C14.59 9.75 14.25 9.41 14.25 9V8C14.25 7.59 14.59 7.25 15 7.25C15.41 7.25 15.75 7.59 15.75 8V9C15.75 9.41 15.41 9.75 15 9.75ZM12 16.75C11.59 16.75 11.25 16.41 11.25 16V8C11.25 7.59 11.59 7.25 12 7.25C12.41 7.25 12.75 7.59 12.75 8V16C12.75 16.41 12.41 16.75 12 16.75ZM15 16.75C14.59 16.75 14.25 16.41 14.25 16V12C14.25 11.59 14.59 11.25 15 11.25C15.41 11.25 15.75 11.59 15.75 12V16C15.75 16.41 15.41 16.75 15 16.75ZM18 16.75C17.59 16.75 17.25 16.41 17.25 16V8C17.25 7.59 17.59 7.25 18 7.25C18.41 7.25 18.75 7.59 18.75 8V16C18.75 16.41 18.41 16.75 18 16.75Z"
        fill={color}
      />
    </>
  );

  return <SwiftIcon color="none" size={size} path={path} />;
}

export function ArrowRight2({ color = ICON_COLORS["SWIFT_COLOR1"], size }) {
  const path = (
    <>
      <path
        d="M8.90999 20.67C8.71999 20.67 8.52999 20.6 8.37999 20.45C8.24051 20.3089 8.16229 20.1184 8.16229 19.92C8.16229 19.7216 8.24051 19.5312 8.37999 19.39L14.9 12.87C15.38 12.39 15.38 11.61 14.9 11.13L8.37999 4.61002C8.24051 4.46888 8.16229 4.27845 8.16229 4.08002C8.16229 3.88159 8.24051 3.69116 8.37999 3.55002C8.66999 3.26002 9.14999 3.26002 9.43999 3.55002L15.96 10.07C16.47 10.58 16.76 11.27 16.76 12C16.76 12.73 16.48 13.42 15.96 13.93L9.43999 20.45C9.28999 20.59 9.09999 20.67 8.90999 20.67Z"
        fill={color}
      />
    </>
  );

  return <SwiftIcon color="none" size={size} path={path} />;
}

export function ArrowDown2({ color = ICON_COLORS["SWIFT_COLOR1"], size }) {
  const path = (
    <>
      <path
        d="M12 16.8C11.3 16.8 10.6 16.53 10.07 16L3.54998 9.48001C3.4105 9.33888 3.33228 9.14844 3.33228 8.95001C3.33228 8.75158 3.4105 8.56115 3.54998 8.42001C3.83998 8.13001 4.31998 8.13001 4.60998 8.42001L11.13 14.94C11.61 15.42 12.39 15.42 12.87 14.94L19.39 8.42001C19.68 8.13001 20.16 8.13001 20.45 8.42001C20.74 8.71001 20.74 9.19001 20.45 9.48001L13.93 16C13.4 16.53 12.7 16.8 12 16.8Z"
        fill={color}
      />
    </>
  );

  return <SwiftIcon color="none" size={size} path={path} />;
}

export function ArrowUp2({ color = ICON_COLORS["SWIFT_COLOR1"], size }) {
  const path = (
    <>
      <path
        d="M19.92 15.8C19.73 15.8 19.54 15.73 19.39 15.58L12.87 9.06001C12.39 8.58001 11.61 8.58001 11.13 9.06001L4.60998 15.58C4.31998 15.87 3.83998 15.87 3.54998 15.58C3.4105 15.4389 3.33228 15.2484 3.33228 15.05C3.33228 14.8516 3.4105 14.6611 3.54998 14.52L10.07 8.00001C10.5832 7.49072 11.2769 7.20493 12 7.20493C12.723 7.20493 13.4167 7.49072 13.93 8.00001L20.45 14.52C20.74 14.81 20.74 15.29 20.45 15.58C20.3 15.72 20.11 15.8 19.92 15.8Z"
        fill={color}
      />
    </>
  );

  return <SwiftIcon color="none" size={size} path={path} />;
}

export function TickCircle({ color = ICON_COLORS["SWIFT_COLOR6"], size }) {
  const path = (
    <>
      <path
        d="M12 22.75C6.07 22.75 1.25 17.93 1.25 12C1.25 6.07 6.07 1.25 12 1.25C17.93 1.25 22.75 6.07 22.75 12C22.75 17.93 17.93 22.75 12 22.75ZM12 2.75C6.9 2.75 2.75 6.9 2.75 12C2.75 17.1 6.9 21.25 12 21.25C17.1 21.25 21.25 17.1 21.25 12C21.25 6.9 17.1 2.75 12 2.75Z"
        fill={color}
      />
      <path
        d="M10.5799 15.582C10.3811 15.5818 10.1904 15.5027 10.0499 15.362L7.2199 12.532C7.08042 12.3909 7.0022 12.2004 7.0022 12.002C7.0022 11.8036 7.08042 11.6131 7.2199 11.472C7.5099 11.182 7.9899 11.182 8.2799 11.472L10.5799 13.772L15.7199 8.63199C16.0099 8.34199 16.4899 8.34199 16.7799 8.63199C17.0699 8.92199 17.0699 9.40199 16.7799 9.69199L11.1099 15.362C10.9694 15.5027 10.7787 15.5818 10.5799 15.582Z"
        fill={color}
      />
    </>
  );

  return <SwiftIcon color="none" size={size} path={path} />;
}

export function CloseCircle({ color = ICON_COLORS["SWIFT_COLOR1"], size }) {
  const path = (
    <>
      <path
        d="M12 22.75C6.07 22.75 1.25 17.93 1.25 12C1.25 6.07 6.07 1.25 12 1.25C17.93 1.25 22.75 6.07 22.75 12C22.75 17.93 17.93 22.75 12 22.75ZM12 2.75C6.9 2.75 2.75 6.9 2.75 12C2.75 17.1 6.9 21.25 12 21.25C17.1 21.25 21.25 17.1 21.25 12C21.25 6.9 17.1 2.75 12 2.75Z"
        fill={color}
      />
      <path
        d="M9.17006 15.58C8.98006 15.58 8.79007 15.51 8.64007 15.36C8.50058 15.2188 8.42236 15.0284 8.42236 14.83C8.42236 14.6316 8.50058 14.4411 8.64007 14.3L14.3001 8.63999C14.5901 8.34999 15.0701 8.34999 15.3601 8.63999C15.6501 8.92999 15.6501 9.40998 15.3601 9.69998L9.70006 15.36C9.56006 15.51 9.36006 15.58 9.17006 15.58Z"
        fill={color}
      />
      <path
        d="M14.8301 15.58C14.6401 15.58 14.4501 15.51 14.3001 15.36L8.64007 9.69998C8.50058 9.55885 8.42236 9.36842 8.42236 9.16999C8.42236 8.97155 8.50058 8.78112 8.64007 8.63999C8.93007 8.34999 9.41006 8.34999 9.70006 8.63999L15.3601 14.3C15.6501 14.59 15.6501 15.07 15.3601 15.36C15.2101 15.51 15.0201 15.58 14.8301 15.58Z"
        fill={color}
      />
    </>
  );

  return <SwiftIcon color="none" size={size} path={path} />;
}

export function ArrowCircleDown({ color = ICON_COLORS["SWIFT_COLOR1"], size }) {
  const path = (
    <>
      <path
        d="M12 22.75C6.07 22.75 1.25 17.93 1.25 12C1.25 6.07 6.07 1.25 12 1.25C17.93 1.25 22.75 6.07 22.75 12C22.75 17.93 17.93 22.75 12 22.75ZM12 2.75C6.9 2.75 2.75 6.9 2.75 12C2.75 17.1 6.9 21.25 12 21.25C17.1 21.25 21.25 17.1 21.25 12C21.25 6.9 17.1 2.75 12 2.75Z"
        fill={color}
      />
      <path
        d="M12 15.25C11.59 15.25 11.25 14.91 11.25 14.5V8.5C11.25 8.09 11.59 7.75 12 7.75C12.41 7.75 12.75 8.09 12.75 8.5V14.5C12.75 14.91 12.41 15.25 12 15.25Z"
        fill={color}
      />
      <path
        d="M11.9999 16.25C11.8099 16.25 11.6199 16.18 11.4699 16.03L8.4699 13.03C8.33042 12.8889 8.2522 12.6984 8.2522 12.5C8.2522 12.3016 8.33042 12.1111 8.4699 11.97C8.7599 11.68 9.2399 11.68 9.5299 11.97L11.9999 14.44L14.4699 11.97C14.7599 11.68 15.2399 11.68 15.5299 11.97C15.8199 12.26 15.8199 12.74 15.5299 13.03L12.5299 16.03C12.3799 16.18 12.1899 16.25 11.9999 16.25Z"
        fill={color}
      />
    </>
  );

  return <SwiftIcon color="none" size={size} path={path} />;
}

export function PlayCircle({ color = ICON_COLORS["SWIFT_COLOR6"], size }) {
  const path = (
    <>
      <path
        d="M11.969 22.75C6.04899 22.75 1.21899 17.93 1.21899 12C1.21899 6.07 6.04899 1.25 11.969 1.25C17.889 1.25 22.719 6.07 22.719 12C22.719 17.93 17.899 22.75 11.969 22.75ZM11.969 2.75C6.86899 2.75 2.71899 6.9 2.71899 12C2.71899 17.1 6.86899 21.25 11.969 21.25C17.069 21.25 21.219 17.1 21.219 12C21.219 6.9 17.069 2.75 11.969 2.75Z"
        fill={color}
      />
      <path
        d="M10.558 16.991C10.118 16.991 9.69804 16.881 9.32804 16.671C8.46804 16.171 7.98804 15.191 7.98804 13.911V10.561C7.98804 9.281 8.45804 8.301 9.31804 7.801C10.178 7.301 11.268 7.381 12.378 8.021L15.278 9.691C16.388 10.331 16.998 11.231 16.998 12.231C16.998 13.221 16.388 14.131 15.278 14.771L12.378 16.441C11.758 16.811 11.128 16.991 10.558 16.991ZM10.558 8.971C10.378 8.971 10.208 9.011 10.078 9.091C9.69804 9.311 9.48804 9.841 9.48804 10.561V13.911C9.48804 14.621 9.69804 15.161 10.078 15.371C10.448 15.591 11.018 15.501 11.638 15.151L14.538 13.481C15.158 13.121 15.508 12.671 15.508 12.241C15.508 11.811 15.148 11.361 14.538 11.001L11.638 9.331C11.238 9.091 10.868 8.971 10.558 8.971Z"
        fill={color}
      />
    </>
  );

  return <SwiftIcon color="none" size={size} path={path} />;
}

export function OrderBook({ color = ICON_COLORS["SWIFT_COLOR1"], size }) {
  const path = (
    <>
      <path
        d="M3.5 18.75C3.09 18.75 2.75 18.41 2.75 18V7C2.75 2.59 4.09 1.25 8.5 1.25H15.5C19.91 1.25 21.25 2.59 21.25 7V17C21.25 17.16 21.25 17.31 21.24 17.47C21.21 17.88 20.84 18.2 20.44 18.17C20.2416 18.1554 20.057 18.0632 19.926 17.9135C19.795 17.7638 19.7282 17.5686 19.74 17.37C19.75 17.25 19.75 17.12 19.75 17V7C19.75 3.43 19.08 2.75 15.5 2.75H8.5C4.92 2.75 4.25 3.43 4.25 7V18C4.25 18.41 3.91 18.75 3.5 18.75Z"
        fill={color}
      />
      <path
        d="M17 22.75H7C5.87364 22.7474 4.79417 22.2987 3.99771 21.5023C3.20126 20.7058 2.75264 19.6264 2.75 18.5V17.85C2.75 15.86 4.37 14.25 6.35 14.25H20.5C20.91 14.25 21.25 14.59 21.25 15V18.5C21.2474 19.6264 20.7987 20.7058 20.0023 21.5023C19.2058 22.2987 18.1264 22.7474 17 22.75ZM6.35 15.75C5.79305 15.75 5.2589 15.9712 4.86508 16.3651C4.47125 16.7589 4.25 17.293 4.25 17.85V18.5C4.25 20.02 5.48 21.25 7 21.25H17C18.52 21.25 19.75 20.02 19.75 18.5V15.75H6.35ZM16 7.75H8C7.59 7.75 7.25 7.41 7.25 7C7.25 6.59 7.59 6.25 8 6.25H16C16.41 6.25 16.75 6.59 16.75 7C16.75 7.41 16.41 7.75 16 7.75ZM13 11.25H8C7.59 11.25 7.25 10.91 7.25 10.5C7.25 10.09 7.59 9.75 8 9.75H13C13.41 9.75 13.75 10.09 13.75 10.5C13.75 10.91 13.41 11.25 13 11.25Z"
        fill={color}
      />
    </>
  );

  return <SwiftIcon color="none" size={size} path={path} />;
}

export function Book1({ color = ICON_COLORS["SWIFT_COLOR1"], size }) {
  const path = (
    <>
      <path
        d="M12 22.08C11.7 22.08 11.4 22.01 11.15 21.87C9.28 20.85 5.99 19.77 3.93 19.5L3.64 19.46C2.33 19.3 1.25 18.07 1.25 16.74V4.66001C1.25 3.87001 1.56 3.15001 2.13 2.63001C2.7 2.11001 3.44 1.86001 4.22 1.93001C6.42 2.10001 9.74 3.20001 11.62 4.38001L11.86 4.52001C11.93 4.56001 12.08 4.56001 12.14 4.53001L12.3 4.43001C14.18 3.25001 17.5 2.13001 19.71 1.94001H19.83C20.56 1.87001 21.31 2.13001 21.87 2.65001C22.44 3.17001 22.75 3.89001 22.75 4.68001V16.75C22.75 18.09 21.67 19.31 20.35 19.47L20.02 19.51C17.96 19.78 14.66 20.87 12.83 21.88C12.59 22.02 12.3 22.08 12 22.08ZM3.98 3.42001C3.66 3.42001 3.37 3.53001 3.14 3.74001C2.89 3.97001 2.75 4.30001 2.75 4.66001V16.74C2.75 17.33 3.26 17.9 3.83 17.98L4.13 18.02C6.38 18.32 9.83 19.45 11.83 20.54C11.92 20.58 12.05 20.59 12.1 20.57C14.1 19.46 17.57 18.32 19.83 18.02L20.17 17.98C20.74 17.91 21.25 17.33 21.25 16.74V4.67001C21.25 4.30001 21.11 3.98001 20.86 3.74001C20.6 3.51001 20.27 3.40001 19.9 3.42001H19.78C17.87 3.59001 14.79 4.62001 13.11 5.67001L12.95 5.78001C12.4 6.12001 11.62 6.12001 11.09 5.79001L10.85 5.65001C9.14 4.60001 6.06 3.58001 4.1 3.42001H3.98Z"
        fill={color}
      />
      <path
        d="M12 21.238C11.59 21.238 11.25 20.898 11.25 20.488V5.48801C11.25 5.07801 11.59 4.73801 12 4.73801C12.41 4.73801 12.75 5.07801 12.75 5.48801V20.488C12.75 20.908 12.41 21.238 12 21.238ZM7.75 9.23801H5.5C5.09 9.23801 4.75 8.89801 4.75 8.48801C4.75 8.07801 5.09 7.73801 5.5 7.73801H7.75C8.16 7.73801 8.5 8.07801 8.5 8.48801C8.5 8.89801 8.16 9.23801 7.75 9.23801ZM8.5 12.238H5.5C5.09 12.238 4.75 11.898 4.75 11.488C4.75 11.078 5.09 10.738 5.5 10.738H8.5C8.91 10.738 9.25 11.078 9.25 11.488C9.25 11.898 8.91 12.238 8.5 12.238Z"
        fill={color}
      />
    </>
  );

  return <SwiftIcon color="none" size={size} path={path} />;
}

export function WalletAdd({ color = ICON_COLORS["SWIFT_COLOR1"], size }) {
  const path = (
    <>
      <path
        d="M14.5 16.191H9.5C9.09 16.191 8.75 15.851 8.75 15.441C8.75 15.031 9.09 14.691 9.5 14.691H14.5C14.91 14.691 15.25 15.031 15.25 15.441C15.25 15.851 14.91 16.191 14.5 16.191Z"
        fill={color}
      />
      <path
        d="M11.9999 18.75C11.5899 18.75 11.2499 18.41 11.2499 18V13C11.2499 12.59 11.5899 12.25 11.9999 12.25C12.4099 12.25 12.7499 12.59 12.7499 13V18C12.7499 18.41 12.4099 18.75 11.9999 18.75ZM5.20195 10.46C5.01195 10.46 4.82195 10.38 4.67195 10.24C4.5673 10.1344 4.49627 10.0002 4.4678 9.85422C4.43932 9.7083 4.45469 9.55721 4.51195 9.42L6.37195 4.98C6.41195 4.89 6.43195 4.83 6.46195 4.78C7.94195 1.37 9.83195 0.539999 13.1719 1.82C13.3619 1.89 13.5119 2.04 13.5919 2.23C13.6719 2.42 13.6719 2.63 13.5919 2.82L10.6619 9.62C10.5419 9.89 10.2719 10.07 9.97195 10.07H7.12195C6.55195 10.07 6.01195 10.18 5.49195 10.4C5.40195 10.44 5.30195 10.46 5.20195 10.46ZM10.6119 2.75C9.37195 2.75 8.61195 3.56 7.82195 5.4C7.81195 5.43 7.79195 5.46 7.78195 5.49L6.47195 8.6C6.69195 8.58 6.90195 8.57 7.12195 8.57H9.47195L11.8819 2.97C11.4119 2.82 10.9919 2.75 10.6119 2.75Z"
        fill={color}
      />
      <path
        d="M18.2881 10.269C18.2181 10.269 18.1381 10.259 18.0681 10.239C17.6981 10.129 17.2881 10.069 16.8681 10.069H9.96806C9.71806 10.069 9.47806 9.93899 9.33806 9.72899C9.27207 9.62404 9.23219 9.50481 9.22175 9.38128C9.21131 9.25775 9.23062 9.13352 9.27806 9.01899L12.1781 2.28899C12.3281 1.92899 12.7681 1.68899 13.1381 1.80899C13.2581 1.84899 13.3681 1.89899 13.4881 1.94899L15.8481 2.93899C17.2281 3.50899 18.1481 4.10899 18.7481 4.82899C18.8681 4.96899 18.9681 5.11899 19.0581 5.26899C19.1681 5.43899 19.2681 5.64899 19.3381 5.85899C19.3681 5.92899 19.4181 6.05899 19.4481 6.19899C19.7281 7.13899 19.5881 8.30899 18.9881 9.80899C18.8681 10.089 18.5881 10.269 18.2881 10.269ZM11.1081 8.56899H16.8781C17.1981 8.56899 17.5081 8.59899 17.8181 8.64899C18.0981 7.77899 18.1581 7.10899 17.9981 6.56899C17.9781 6.47899 17.9581 6.43899 17.9481 6.39899C17.8881 6.23899 17.8481 6.14899 17.7981 6.06899C17.7281 5.95899 17.6781 5.86899 17.5981 5.77899C17.1681 5.25899 16.4081 4.77899 15.2781 4.31899L13.2981 3.48899L11.1081 8.56899Z"
        fill={color}
      />
      <path
        d="M15.9 22.75H8.1C7.82 22.75 7.56 22.73 7.3 22.7C3.79 22.46 1.79 20.46 1.55 16.91C1.52 16.69 1.5 16.42 1.5 16.15V14.2C1.5 11.95 2.84 9.92001 4.91 9.02001C5.61 8.72001 6.36 8.57001 7.13 8.57001H16.89C17.46 8.57001 18.01 8.65001 18.52 8.81001C20.87 9.52001 22.52 11.74 22.52 14.2V16.15C22.52 16.37 22.51 16.58 22.5 16.78C22.28 20.69 20 22.75 15.9 22.75ZM7.12 10.07C6.55 10.07 6.01 10.18 5.49 10.4C3.97 11.06 2.99 12.55 2.99 14.2V16.15C2.99 16.36 3.01 16.57 3.03 16.77C3.22 19.62 4.62 21.02 7.43 21.21C7.68 21.24 7.88 21.26 8.09 21.26H15.89C19.19 21.26 20.81 19.81 20.97 16.71C20.98 16.53 20.99 16.35 20.99 16.15V14.2C20.99 12.39 19.78 10.77 18.06 10.24C17.69 10.13 17.28 10.07 16.86 10.07H7.12Z"
        fill={color}
      />
      <path
        d="M2.23804 14.952C1.82804 14.952 1.48804 14.612 1.48804 14.202V11.272C1.48804 8.122 3.71804 5.402 6.79804 4.802C7.06804 4.752 7.34804 4.852 7.52804 5.062C7.69804 5.272 7.74804 5.572 7.63804 5.822L5.88804 10.002C5.81033 10.1779 5.67188 10.3199 5.49804 10.402C3.97804 11.062 2.99804 12.552 2.99804 14.202C2.98804 14.612 2.65804 14.952 2.23804 14.952ZM5.59804 6.822C4.95748 7.18312 4.40248 7.67834 3.971 8.27378C3.53952 8.86922 3.24174 9.55084 3.09804 10.272C3.53804 9.822 4.04804 9.442 4.62804 9.162L5.59804 6.822ZM21.761 14.95C21.351 14.95 21.011 14.61 21.011 14.2C21.011 12.39 19.801 10.77 18.081 10.24C17.9817 10.2107 17.8896 10.1609 17.8106 10.0939C17.7316 10.027 17.6675 9.94424 17.6223 9.85105C17.5771 9.75786 17.5519 9.65627 17.5482 9.55277C17.5446 9.44927 17.5626 9.34615 17.601 9.25C18.071 8.08 18.191 7.23 18.001 6.57C17.981 6.48 17.961 6.44 17.951 6.4C17.8882 6.25809 17.8708 6.10022 17.9012 5.94804C17.9317 5.79586 18.0085 5.65682 18.121 5.55C18.351 5.33 18.701 5.28 18.981 5.43C20.0479 5.98671 20.9413 6.8258 21.5639 7.85567C22.1864 8.88553 22.514 10.0666 22.511 11.27V14.2C22.511 14.61 22.171 14.95 21.761 14.95ZM19.251 9.09C19.881 9.38 20.441 9.79 20.911 10.28C20.721 9.3 20.251 8.41 19.561 7.71C19.511 8.13 19.411 8.59 19.251 9.09Z"
        fill={color}
      />
    </>
  );

  return <SwiftIcon color="none" size={size} path={path} />;
}

export function BookMark({ color = ICON_COLORS["SWIFT_COLOR1"], size }) {
  const path = (
    <>
      <path
        d="M12.89 5.87988H5.11C4.28599 5.88252 3.49648 6.21103 2.91381 6.79369C2.33114 7.37636 2.00264 8.16587 2 8.98988V20.3499C2 21.7999 3.04 22.4199 4.31 21.7099L8.24 19.5199C8.66 19.2899 9.34 19.2899 9.75 19.5199L13.68 21.7099C14.95 22.4199 15.99 21.7999 15.99 20.3499V8.98988C15.9907 8.58213 15.911 8.17824 15.7556 7.80127C15.6001 7.4243 15.372 7.08164 15.0841 6.79285C14.7962 6.50406 14.4543 6.2748 14.0779 6.11815C13.7014 5.9615 13.2978 5.88054 12.89 5.87988Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 8.98988V20.3499C16 21.7999 14.96 22.4099 13.69 21.7099L9.76 19.5199C9.34 19.2899 8.66 19.2899 8.24 19.5199L4.31 21.7099C3.04 22.4099 2 21.7999 2 20.3499V8.98988C2 7.27988 3.4 5.87988 5.11 5.87988H12.89C14.6 5.87988 16 7.27988 16 8.98988Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22 5.11V16.47C22 17.92 20.96 18.53 19.69 17.83L16 15.77V8.99C16 7.28 14.6 5.88 12.89 5.88H8V5.11C8 3.4 9.4 2 11.11 2H18.89C20.6 2 22 3.4 22 5.11Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  );

  return <SwiftIcon color="none" size={size} path={path} />;
}

export function FileUpload({ color = ICON_COLORS["SWIFT_COLOR1"], size }) {
  const path = (
    <>
      <path
        d="M14 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22M14 2V6C14 9 15 10 18 10H22M14 2L22 10M22 10V13"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.76 18.2598C11.41 18.4298 11.41 21.8298 13.76 21.9998H19.32C19.99 21.9998 20.65 21.7498 21.14 21.2998C22.79 19.8598 21.91 16.9798 19.74 16.7098C18.96 12.0198 12.18 13.7998 13.78 18.2698"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  );

  return <SwiftIcon color="none" size={size} path={path} />;
}

export function BoxTick({ color = ICON_COLORS["SWIFT_COLOR6"], size }) {
  const path = (
    <>
      <path
        d="M19.001 22.75C18.1995 22.7492 17.4112 22.5452 16.7099 22.1569C16.0086 21.7687 15.4172 21.2089 14.991 20.53C14.531 19.82 14.271 18.97 14.251 18.1C14.221 16.64 14.841 15.28 15.951 14.36C16.7795 13.6719 17.8146 13.2812 18.891 13.25C20.191 13.24 21.361 13.69 22.281 14.57C23.201 15.45 23.721 16.63 23.741 17.9C23.761 18.77 23.541 19.62 23.101 20.37C22.861 20.79 22.551 21.18 22.181 21.51C21.361 22.28 20.261 22.73 19.091 22.75H19.001ZM19.001 14.75H18.931C18.191 14.77 17.491 15.03 16.911 15.51C16.151 16.14 15.731 17.07 15.751 18.07C15.761 18.66 15.941 19.24 16.251 19.73C16.861 20.71 17.921 21.31 19.061 21.25C19.8446 21.2337 20.595 20.9314 21.171 20.4C21.431 20.17 21.641 19.91 21.801 19.63C22.101 19.11 22.251 18.53 22.241 17.94C22.221 17.07 21.871 16.26 21.241 15.66C20.641 15.07 19.841 14.75 19.001 14.75Z"
        fill={color}
      />
      <path
        d="M18.449 19.75C18.255 19.7499 18.0687 19.6746 17.929 19.54L16.919 18.58C16.8476 18.512 16.7905 18.4305 16.7508 18.3402C16.7112 18.25 16.6898 18.1527 16.6879 18.0542C16.6861 17.9556 16.7038 17.8577 16.74 17.766C16.7762 17.6743 16.8303 17.5907 16.899 17.52C17.189 17.22 17.659 17.21 17.959 17.5L18.449 17.97L20.019 16.45C20.319 16.16 20.789 16.17 21.079 16.47C21.369 16.77 21.359 17.24 21.059 17.53L18.969 19.55C18.819 19.68 18.629 19.75 18.449 19.75ZM12.001 13.3C11.871 13.3 11.741 13.27 11.621 13.2L2.79099 8.09001C2.70554 8.0402 2.63076 7.97401 2.57093 7.89525C2.51109 7.81649 2.46738 7.7267 2.4423 7.63103C2.41722 7.53535 2.41126 7.43566 2.42477 7.33768C2.43827 7.23969 2.47097 7.14534 2.52099 7.06001C2.73099 6.70001 3.19099 6.58001 3.54099 6.79001L11.991 11.68L20.391 6.82001C20.751 6.61001 21.211 6.74001 21.411 7.09001C21.621 7.45001 21.491 7.91001 21.141 8.12001L12.371 13.2C12.261 13.26 12.131 13.3 12.001 13.3Z"
        fill={color}
      />
      <path
        d="M12 22.36C11.59 22.36 11.25 22.02 11.25 21.61V12.54C11.25 12.13 11.59 11.79 12 11.79C12.41 11.79 12.75 12.13 12.75 12.54V21.61C12.75 22.02 12.41 22.36 12 22.36Z"
        fill={color}
      />
      <path
        d="M11.9989 22.752C11.1189 22.752 10.2389 22.562 9.55891 22.172L4.21891 19.212C2.76891 18.412 1.62891 16.482 1.62891 14.822V9.162C1.62891 7.502 2.76891 5.582 4.21891 4.772L9.55891 1.812C10.9189 1.042 13.0589 1.042 14.4289 1.812L19.7689 4.772C21.2189 5.572 22.3589 7.502 22.3589 9.162V14.822C22.3589 14.922 22.3589 15.002 22.3389 15.102C22.2889 15.362 22.0989 15.582 21.8489 15.662C21.5989 15.752 21.3189 15.692 21.1089 15.522C19.9589 14.522 18.1789 14.482 16.9689 15.452C16.3536 15.9405 15.9379 16.6368 15.7998 17.4102C15.6617 18.1836 15.8107 18.9807 16.2189 19.652C16.2989 19.792 16.3789 19.902 16.4689 20.012C16.5426 20.0958 16.5963 20.1952 16.626 20.3028C16.6557 20.4103 16.6606 20.5232 16.6404 20.6329C16.6202 20.7427 16.5754 20.8464 16.5093 20.9363C16.4432 21.0262 16.3576 21.0999 16.2589 21.152L14.4289 22.162C13.7489 22.562 12.8789 22.752 11.9989 22.752ZM11.9989 2.752C11.3789 2.752 10.7489 2.882 10.2989 3.132L4.95891 6.092C3.98891 6.622 3.14891 8.062 3.14891 9.162V14.822C3.14891 15.922 3.99891 17.362 4.95891 17.892L10.2989 20.852C11.2089 21.362 12.7989 21.362 13.7089 20.852L14.8289 20.232C14.4526 19.5419 14.2565 18.768 14.2589 17.982C14.2589 16.522 14.9089 15.172 16.0389 14.272C17.3989 13.182 19.3389 12.952 20.8689 13.602V9.142C20.8689 8.042 20.0189 6.602 19.0589 6.072L13.7189 3.112C13.2489 2.882 12.6189 2.752 11.9989 2.752Z"
        fill={color}
      />
    </>
  );

  return <SwiftIcon color="none" size={size} path={path} />;
}

export function ArrowDown({ color = ICON_COLORS["SWIFT_COLOR1"], size }) {
  const path = (
    <>
      <path
        d="M12.0001 21.25C11.8101 21.25 11.6201 21.18 11.4701 21.03L5.40007 14.96C5.26059 14.8189 5.18237 14.6284 5.18237 14.43C5.18237 14.2316 5.26059 14.0411 5.40007 13.9C5.69007 13.61 6.17007 13.61 6.46007 13.9L12.0001 19.44L17.5401 13.9C17.8301 13.61 18.3101 13.61 18.6001 13.9C18.8901 14.19 18.8901 14.67 18.6001 14.96L12.5301 21.03C12.3801 21.18 12.1901 21.25 12.0001 21.25Z"
        fill={color}
      />
      <path
        d="M12 21.08C11.59 21.08 11.25 20.74 11.25 20.33V3.5C11.25 3.09 11.59 2.75 12 2.75C12.41 2.75 12.75 3.09 12.75 3.5V20.33C12.75 20.74 12.41 21.08 12 21.08Z"
        fill={color}
      />
    </>
  );

  return <SwiftIcon color="none" size={size} path={path} />;
}

export function Cross({ color = ICON_COLORS["SWIFT_COLOR1"], size }) {
  const path = (
    <>
      <path
        d="M17.0763 17.0763C16.7864 17.3662 16.3055 17.3662 16.0156 17.0763L7.53033 8.59098C7.24042 8.30107 7.24042 7.82024 7.53033 7.53032C7.82024 7.24041 8.30108 7.24041 8.59099 7.53032L17.0763 16.0156C17.3662 16.3055 17.3662 16.7864 17.0763 17.0763Z"
        fill={color}
      />
      <path
        d="M17.0763 8.59099L8.59099 17.0763C8.30108 17.3662 7.82024 17.3662 7.53033 17.0763C7.24042 16.7864 7.24042 16.3055 7.53033 16.0156L16.0156 7.53033C16.3055 7.24042 16.7864 7.24042 17.0763 7.53033C17.3662 7.82025 17.3662 8.30108 17.0763 8.59099Z"
        fill={color}
      />
    </>
  );

  return <SwiftIcon color="none" size={size} path={path} />;
}

export function ArrowRight2Bold({ color = ICON_COLORS["SWIFT_COLOR1"], size }) {
  const path = (
    <>
      <path
        d="M15.1999 10.492L13.2299 8.522L10.0199 5.312C9.33993 4.642 8.17993 5.122 8.17993 6.082V17.922C8.17993 18.882 9.33993 19.362 10.0199 18.682L15.1999 13.502C16.0299 12.682 16.0299 11.322 15.1999 10.492Z"
        fill={color}
      />
    </>
  );

  return <SwiftIcon color="none" size={size} path={path} />;
}

export function ArrowDown2Bold({ color = ICON_COLORS["SWIFT_COLOR1"], size }) {
  const path = (
    <>
      <path
        d="M17.919 8.17999H6.07902C5.11902 8.17999 4.63902 9.33999 5.31902 10.02L10.499 15.2C11.329 16.03 12.679 16.03 13.509 15.2L15.479 13.23L18.689 10.02C19.359 9.33999 18.879 8.17999 17.919 8.17999Z"
        fill={color}
      />
    </>
  );

  return <SwiftIcon color="none" size={size} path={path} />;
}

export function Minus({ color = ICON_COLORS["SWIFT_COLOR1"], size }) {
  const path = (
    <>
      <path
        d="M18 12.75H6C5.59 12.75 5.25 12.41 5.25 12C5.25 11.59 5.59 11.25 6 11.25H18C18.41 11.25 18.75 11.59 18.75 12C18.75 12.41 18.41 12.75 18 12.75Z"
        fill={color}
      />
    </>
  );

  return <SwiftIcon color="none" size={size} path={path} />;
}

export function Monitor({ color = ICON_COLORS["SWIFT_COLOR1"], size }) {
  const path = (
    <>
      <path
        d="M17.56 17.97H6.44C2.46 17.97 1.25 16.76 1.25 12.78V6.44C1.25 2.46 2.46 1.25 6.44 1.25H17.55C21.53 1.25 22.74 2.46 22.74 6.44V12.77C22.75 16.76 21.54 17.97 17.56 17.97ZM6.44 2.75C3.3 2.75 2.75 3.3 2.75 6.44V12.77C2.75 15.91 3.3 16.46 6.44 16.46H17.55C20.69 16.46 21.24 15.91 21.24 12.77V6.44C21.24 3.3 20.69 2.75 17.55 2.75H6.44Z"
        fill={color}
      />
      <path
        d="M12 22.749C11.59 22.749 11.25 22.409 11.25 21.999V17.219C11.25 16.809 11.59 16.469 12 16.469C12.41 16.469 12.75 16.809 12.75 17.219V21.999C12.75 22.409 12.41 22.749 12 22.749ZM22 13.75H2C1.59 13.75 1.25 13.41 1.25 13C1.25 12.59 1.59 12.25 2 12.25H22C22.41 12.25 22.75 12.59 22.75 13C22.75 13.41 22.41 13.75 22 13.75Z"
        fill={color}
      />
      <path
        d="M16.5 22.75H7.5C7.09 22.75 6.75 22.41 6.75 22C6.75 21.59 7.09 21.25 7.5 21.25H16.5C16.91 21.25 17.25 21.59 17.25 22C17.25 22.41 16.91 22.75 16.5 22.75Z"
        fill={color}
      />
    </>
  );

  return <SwiftIcon color="none" size={size} path={path} />;
}

export function Bag2({ color = ICON_COLORS["SWIFT_COLOR1"], size }) {
  const path = (
    <>
      <path
        d="M16.5 8.62999C16.09 8.62999 15.75 8.28999 15.75 7.87999V6.49999C15.75 5.44999 15.3 4.42999 14.52 3.71999C13.73 2.99999 12.71 2.66999 11.63 2.76999C9.83 2.93999 8.25 4.77999 8.25 6.69999V7.66999C8.25 8.07999 7.91 8.41999 7.5 8.41999C7.09 8.41999 6.75 8.07999 6.75 7.66999V6.68999C6.75 3.99999 8.92 1.51999 11.49 1.26999C12.99 1.12999 14.43 1.59999 15.53 2.60999C16.0712 3.1033 16.5037 3.704 16.7999 4.37377C17.096 5.04354 17.2493 5.76767 17.25 6.49999V7.87999C17.25 8.28999 16.91 8.62999 16.5 8.62999Z"
        fill={color}
      />
      <path
        d="M15.0001 22.75H9.00006C4.38006 22.75 3.52006 20.6 3.30006 18.51L2.55006 12.52C2.44006 11.44 2.40006 9.89 3.45006 8.73C4.35006 7.73 5.84006 7.25 8.00006 7.25H16.0001C18.1701 7.25 19.6601 7.74 20.5501 8.73C21.5901 9.89 21.5601 11.44 21.4501 12.5L20.7001 18.51C20.4801 20.6 19.6201 22.75 15.0001 22.75ZM8.00006 8.75C6.31006 8.75 5.15006 9.08 4.56006 9.74C4.07006 10.28 3.91006 11.11 4.04006 12.35L4.79006 18.34C4.96006 19.94 5.40006 21.26 9.00006 21.26H15.0001C18.6001 21.26 19.0401 19.95 19.2101 18.36L19.9601 12.35C20.0901 11.13 19.9301 10.3 19.4401 9.75C18.8501 9.08 17.6901 8.75 16.0001 8.75H8.00006Z"
        fill={color}
      />
      <path
        d="M15.4199 13.148C14.8599 13.148 14.4099 12.698 14.4099 12.148C14.4099 11.598 14.8599 11.148 15.4099 11.148C15.9599 11.148 16.4099 11.598 16.4099 12.148C16.4099 12.698 15.9699 13.148 15.4199 13.148ZM8.41991 13.148C7.85991 13.148 7.40991 12.698 7.40991 12.148C7.40991 11.598 7.85991 11.148 8.40991 11.148C8.95991 11.148 9.40991 11.598 9.40991 12.148C9.40991 12.698 8.96991 13.148 8.41991 13.148Z"
        fill={color}
      />
    </>
  );

  return <SwiftIcon color="none" size={size} path={path} />;
}

export function Tick({ color = ICON_COLORS["SWIFT_COLOR1"], size }) {
  const path = (
    <>
      <path
        d="M10.0112 17C9.73267 16.9998 9.46565 16.8894 9.26883 16.6931L5.30493 12.7447C5.10956 12.5478 5 12.2821 5 12.0052C5 11.7284 5.10956 11.4627 5.30493 11.2658C5.71112 10.8612 6.38345 10.8612 6.78964 11.2658L10.0112 14.4747L17.2106 7.30345C17.6168 6.89885 18.2892 6.89885 18.6954 7.30345C19.1015 7.70806 19.1015 8.37775 18.6954 8.78235L10.7535 16.6931C10.5567 16.8894 10.2897 16.9998 10.0112 17Z"
        fill={color}
      />
    </>
  );

  return <SwiftIcon color="none" size={size} path={path} />;
}

export function Login({ color = ICON_COLORS["SWIFT_COLOR1"], size }) {
  const path = (
    <>
      <path
        d="M11.6801 15.37C11.4901 15.37 11.3001 15.3 11.1501 15.15C11.0106 15.0089 10.9324 14.8184 10.9324 14.62C10.9324 14.4216 11.0106 14.2311 11.1501 14.09L13.1801 12.06L11.1501 10.03C11.0106 9.88886 10.9324 9.69843 10.9324 9.5C10.9324 9.30157 11.0106 9.11114 11.1501 8.97C11.4401 8.68 11.9201 8.68 12.2101 8.97L14.7701 11.53C15.0601 11.82 15.0601 12.3 14.7701 12.59L12.2101 15.15C12.0701 15.3 11.8701 15.37 11.6801 15.37Z"
        fill={color}
      />
      <path
        d="M14.17 12.81H4C3.59 12.81 3.25 12.47 3.25 12.06C3.25 11.65 3.59 11.31 4 11.31H14.17C14.58 11.31 14.92 11.65 14.92 12.06C14.92 12.47 14.58 12.81 14.17 12.81Z"
        fill={color}
      />
      <path
        d="M12 20.75C11.59 20.75 11.25 20.41 11.25 20C11.25 19.59 11.59 19.25 12 19.25C16.27 19.25 19.25 16.27 19.25 12C19.25 7.73 16.27 4.75 12 4.75C11.59 4.75 11.25 4.41 11.25 4C11.25 3.59 11.59 3.25 12 3.25C17.15 3.25 20.75 6.85 20.75 12C20.75 17.15 17.15 20.75 12 20.75Z"
        fill={color}
      />
    </>
  );

  return <SwiftIcon color="none" size={size} path={path} />;
}

export function NotificationStatus({
  color = ICON_COLORS["SWIFT_COLOR1"],
  size,
}) {
  const path = (
    <>
      <path
        d="M19 8.75C16.93 8.75 15.25 7.07 15.25 5C15.25 2.93 16.93 1.25 19 1.25C21.07 1.25 22.75 2.93 22.75 5C22.75 7.07 21.07 8.75 19 8.75ZM19 2.75C17.76 2.75 16.75 3.76 16.75 5C16.75 6.24 17.76 7.25 19 7.25C20.24 7.25 21.25 6.24 21.25 5C21.25 3.76 20.24 2.75 19 2.75ZM12 13.75H7C6.59 13.75 6.25 13.41 6.25 13C6.25 12.59 6.59 12.25 7 12.25H12C12.41 12.25 12.75 12.59 12.75 13C12.75 13.41 12.41 13.75 12 13.75ZM16 17.75H7C6.59 17.75 6.25 17.41 6.25 17C6.25 16.59 6.59 16.25 7 16.25H16C16.41 16.25 16.75 16.59 16.75 17C16.75 17.41 16.41 17.75 16 17.75Z"
        fill={color}
      />
      <path
        d="M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H14C14.41 1.25 14.75 1.59 14.75 2C14.75 2.41 14.41 2.75 14 2.75H9C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V10C21.25 9.59 21.59 9.25 22 9.25C22.41 9.25 22.75 9.59 22.75 10V15C22.75 20.43 20.43 22.75 15 22.75Z"
        fill={color}
      />
    </>
  );

  return <SwiftIcon color="none" size={size} path={path} />;
}

export function NotePad({ color = ICON_COLORS["SWIFT_COLOR1"], size }) {
  const path = (
    <>
      <path
        d="M15.8101 20.179C15.5501 20.179 15.2801 20.169 14.9901 20.139C14.4701 20.099 13.8801 19.999 13.2701 19.849L11.5901 19.449C6.98007 18.359 5.47007 15.919 6.55007 11.319L7.53007 7.12899C7.75007 6.17899 8.01007 5.40899 8.33007 4.76899C10.0501 1.21899 13.3401 1.53899 15.6801 2.08899L17.3501 2.47899C19.6901 3.02899 21.1701 3.89899 22.0001 5.22899C22.8201 6.55899 22.9501 8.26899 22.4001 10.609L21.4201 14.789C20.5601 18.449 18.7701 20.179 15.8101 20.179ZM13.1201 3.24899C11.4501 3.24899 10.3901 3.93899 9.68007 5.41899C9.42007 5.95899 9.19007 6.62899 8.99007 7.46899L8.01007 11.659C7.12007 15.439 8.15007 17.089 11.9301 17.989L13.6101 18.389C14.1501 18.519 14.6601 18.599 15.1201 18.639C17.8301 18.909 19.1901 17.719 19.9501 14.449L20.9301 10.269C21.3801 8.33899 21.3201 6.98899 20.7201 6.01899C20.1201 5.04899 18.9401 4.38899 17.0001 3.93899L15.3301 3.54899C14.5001 3.34899 13.7601 3.24899 13.1201 3.24899Z"
        fill={color}
      />
      <path
        d="M8.33005 22.252C5.76005 22.252 4.12005 20.712 3.07005 17.462L1.79005 13.512C0.370052 9.112 1.64005 6.632 6.02005 5.212L7.60005 4.702C8.12005 4.542 8.51005 4.432 8.86005 4.372C9.14005 4.312 9.43005 4.422 9.60005 4.652C9.77005 4.882 9.80005 5.182 9.68005 5.442C9.42005 5.972 9.19005 6.642 9.00005 7.482L8.02005 11.672C7.13005 15.452 8.16005 17.102 11.9401 18.002L13.6201 18.402C14.1601 18.532 14.6701 18.612 15.1301 18.652C15.4501 18.682 15.7101 18.902 15.8001 19.212C15.8801 19.522 15.7601 19.842 15.5001 20.022C14.8401 20.472 14.0101 20.852 12.9601 21.192L11.3801 21.712C10.2301 22.072 9.23005 22.252 8.33005 22.252ZM7.78005 6.222L6.49005 6.642C2.92005 7.792 2.07005 9.472 3.22005 13.052L4.50005 17.002C5.66005 20.572 7.34005 21.432 10.9101 20.282L12.4901 19.762C12.5501 19.742 12.6001 19.722 12.6601 19.702L11.6001 19.452C6.99005 18.362 5.48005 15.922 6.56005 11.322L7.54005 7.132C7.61005 6.812 7.69005 6.502 7.78005 6.222Z"
        fill={color}
      />
    </>
  );

  return <SwiftIcon color="none" size={size} path={path} />;
}

export function Cards({ color = ICON_COLORS["SWIFT_COLOR1"], size }) {
  const path = (
    <>
      <path
        d="M19 13.36H2C1.59 13.36 1.25 13.02 1.25 12.61C1.25 12.2 1.59 11.86 2 11.86H19C19.41 11.86 19.75 12.2 19.75 12.61C19.75 13.02 19.41 13.36 19 13.36Z"
        fill={color}
      />
      <path
        d="M15.22 21.75H5.78C2.35 21.75 1.25 20.66 1.25 17.27V10.28C1.25 7.59 1.86 6 4.96 5.82C5.22 5.81 5.49 5.8 5.78 5.8H15.22C18.65 5.8 19.75 6.89 19.75 10.28V17.43C19.71 20.7 18.61 21.75 15.22 21.75ZM5.78 7.3C5.51 7.3 5.26 7.31 5.03 7.32C3.24 7.43 2.75 7.81 2.75 10.28V17.27C2.75 19.83 3.17 20.25 5.78 20.25H15.22C17.8 20.25 18.22 19.85 18.25 17.42V10.28C18.25 7.72 17.83 7.3 15.22 7.3H5.78Z"
        fill={color}
      />
      <path
        d="M19.0001 18.18C18.8101 18.18 18.6201 18.11 18.4901 17.98C18.4147 17.9096 18.3544 17.8244 18.3132 17.7298C18.2719 17.6352 18.2504 17.5332 18.2501 17.43V10.28C18.2501 7.72 17.8301 7.3 15.2201 7.3H5.78008C5.51008 7.3 5.26008 7.31 5.03008 7.32C4.83008 7.33 4.63008 7.25 4.48008 7.11C4.40604 7.03903 4.3474 6.95356 4.30783 6.85894C4.26826 6.76431 4.2486 6.66255 4.25008 6.56C4.29008 3.3 5.39008 2.25 8.78008 2.25H18.2201C21.6501 2.25 22.7501 3.34 22.7501 6.73V13.72C22.7501 16.41 22.1401 18 19.0401 18.18H19.0001ZM5.78008 5.8H15.2201C18.6501 5.8 19.7501 6.89 19.7501 10.28V16.6C20.9101 16.39 21.2501 15.79 21.2501 13.72V6.73C21.2501 4.17 20.8301 3.75 18.2201 3.75H8.78008C6.50008 3.75 5.91008 4.06 5.78008 5.8ZM6.96208 18.559H5.24208C4.83208 18.559 4.49208 18.219 4.49208 17.809C4.49208 17.399 4.83208 17.059 5.24208 17.059H6.96208C7.16099 17.059 7.35176 17.138 7.49241 17.2787C7.63306 17.4193 7.71208 17.6101 7.71208 17.809C7.71208 18.0079 7.63306 18.1987 7.49241 18.3393C7.35176 18.48 7.16099 18.559 6.96208 18.559ZM12.5501 18.559H9.11008C8.70008 18.559 8.36008 18.219 8.36008 17.809C8.36008 17.399 8.70008 17.059 9.11008 17.059H12.5501C12.749 17.059 12.9398 17.138 13.0804 17.2787C13.2211 17.4193 13.3001 17.6101 13.3001 17.809C13.3001 18.0079 13.2211 18.1987 13.0804 18.3393C12.9398 18.48 12.749 18.559 12.5501 18.559Z"
        fill={color}
      />
    </>
  );

  return <SwiftIcon color="none" size={size} path={path} />;
}

export function UserCircleAdd({ color = ICON_COLORS["SWIFT_COLOR1"], size }) {
  const path = (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.458 14.48C9.49802 14.48 7.89802 12.88 7.89802 10.92C7.89802 8.96 9.49802 7.36 11.458 7.36C13.418 7.36 15.018 8.96 15.018 10.92C15.018 12.88 13.418 14.48 11.458 14.48ZM11.458 8.87C10.328 8.87 9.39802 9.79 9.39802 10.93C9.39802 12.07 10.318 12.99 11.458 12.99C12.598 12.99 13.518 12.07 13.518 10.93C13.518 9.79 12.598 8.87 11.458 8.87ZM16.65 20.949C16.24 20.949 15.9 20.609 15.9 20.199C15.9 18.279 13.91 16.719 11.46 16.719C9.01002 16.719 7.02002 18.279 7.02002 20.199C7.02002 20.609 6.68002 20.949 6.27002 20.949C5.86002 20.949 5.52002 20.609 5.52002 20.199C5.52002 17.459 8.18002 15.219 11.46 15.219C14.74 15.219 17.4 17.449 17.4 20.199C17.4 20.609 17.06 20.949 16.65 20.949Z"
          fill={color}
        />
        <path
          d="M11.5 22.75C5.85 22.75 1.25 18.15 1.25 12.5C1.25 6.85 5.85 2.25 11.5 2.25C12.89 2.25 14.23 2.52 15.49 3.05C15.85 3.2 16.03 3.6 15.91 3.97C15.8 4.3 15.75 4.65 15.75 5C15.75 5.59 15.91 6.17 16.22 6.67C16.38 6.95 16.59 7.2 16.83 7.41C17.7 8.2 18.99 8.45 20 8.09C20.37 7.95 20.79 8.14 20.94 8.51C21.48 9.78 21.75 11.13 21.75 12.51C21.75 18.15 17.15 22.75 11.5 22.75ZM11.5 3.75C6.68 3.75 2.75 7.67 2.75 12.5C2.75 17.33 6.68 21.25 11.5 21.25C16.32 21.25 20.25 17.33 20.25 12.5C20.25 11.54 20.09 10.59 19.79 9.68C19.0868 9.79534 18.3666 9.75097 17.6828 9.55016C16.999 9.34936 16.3692 8.99728 15.84 8.52C15.49 8.22 15.18 7.85 14.94 7.44C14.3541 6.47201 14.1375 5.325 14.33 4.21C13.42 3.9 12.47 3.75 11.5 3.75Z"
          fill={color}
        />
        <path
          d="M19 9.75C17.8269 9.74999 16.6961 9.31126 15.83 8.52C15.48 8.22 15.17 7.85 14.93 7.44C14.49 6.72 14.25 5.87 14.25 5C14.25 4.49 14.33 3.99 14.49 3.51C14.71 2.83 15.09 2.2 15.6 1.69C16.5 0.77 17.71 0.25 19.01 0.25C20.37 0.25 21.66 0.83 22.54 1.83C23.3243 2.69967 23.7589 3.8289 23.76 5C23.76 5.38 23.71 5.76 23.61 6.12C23.51 6.57 23.32 7.04 23.06 7.45C22.4819 8.42786 21.5632 9.15787 20.48 9.5C20.03 9.67 19.53 9.75 19 9.75ZM19 1.75C18.11 1.75 17.28 2.1 16.67 2.73C16.32 3.09 16.07 3.5 15.92 3.97C15.81 4.3 15.76 4.65 15.76 5C15.76 5.59 15.92 6.17 16.23 6.67C16.39 6.95 16.6 7.2 16.84 7.41C17.71 8.2 19 8.45 20.01 8.09C20.77 7.85 21.39 7.35 21.79 6.68C21.97 6.39 22.09 6.08 22.16 5.77C22.23 5.51 22.26 5.26 22.26 5C22.26 4.2 21.96 3.43 21.42 2.83C21.1163 2.48859 20.7435 2.21571 20.3263 2.0295C19.909 1.84329 19.4569 1.74802 19 1.75Z"
          fill={color}
        />
        <path
          d="M20.49 5.73H17.5C17.09 5.73 16.75 5.39 16.75 4.98C16.75 4.57 17.09 4.23 17.5 4.23H20.49C20.6889 4.23 20.8797 4.30901 21.0203 4.44967C21.161 4.59032 21.24 4.78108 21.24 4.98C21.24 5.17891 21.161 5.36967 21.0203 5.51033C20.8797 5.65098 20.6889 5.73 20.49 5.73Z"
          fill={color}
        />
        <path
          d="M19 7.26C18.59 7.26 18.25 6.92 18.25 6.51V3.52C18.25 3.11 18.59 2.77 19 2.77C19.41 2.77 19.75 3.11 19.75 3.52V6.51C19.75 6.93 19.41 7.26 19 7.26Z"
          fill={color}
        />
      </svg>
    </>
  );

  return <SwiftIcon color="none" size={size} path={path} />;
}

export function ReceiptSearch({ color = ICON_COLORS["SWIFT_COLOR1"], size }) {
  const path = (
    <>
      <path
        d="M20.5 11.3V7.04C20.5 3.01 19.56 2 15.78 2H8.22C4.44 2 3.5 3.01 3.5 7.04V18.3C3.5 20.96 4.96 21.59 6.73 19.69L6.74 19.68C7.56 18.81 8.81 18.88 9.52 19.83L10.53 21.18"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22 22L21 21M8 7H16M9 11H15M18.2 21.4C19.0487 21.4 19.8626 21.0629 20.4627 20.4627C21.0629 19.8626 21.4 19.0487 21.4 18.2C21.4 17.3513 21.0629 16.5374 20.4627 15.9373C19.8626 15.3371 19.0487 15 18.2 15C17.3513 15 16.5374 15.3371 15.9373 15.9373C15.3371 16.5374 15 17.3513 15 18.2C15 19.0487 15.3371 19.8626 15.9373 20.4627C16.5374 21.0629 17.3513 21.4 18.2 21.4Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  );

  return <SwiftIcon color="none" size={size} path={path} />;
}

export function Notification({ color = ICON_COLORS["SWIFT_COLOR1"], size }) {
  const path = (
    <>
      <path
        d="M12.0201 20.532C9.69011 20.532 7.36011 20.162 5.15011 19.422C4.31011 19.132 3.67011 18.542 3.39011 17.772C3.10011 17.002 3.20011 16.152 3.66011 15.392L4.81011 13.482C5.05011 13.082 5.27011 12.282 5.27011 11.812V8.922C5.27011 5.202 8.30011 2.172 12.0201 2.172C15.7401 2.172 18.7701 5.202 18.7701 8.922V11.812C18.7701 12.272 18.9901 13.082 19.2301 13.492L20.3701 15.392C20.8001 16.112 20.8801 16.982 20.5901 17.772C20.4485 18.1585 20.221 18.5078 19.9248 18.7936C19.6286 19.0794 19.2714 19.2943 18.8801 19.422C16.6801 20.162 14.3501 20.532 12.0201 20.532ZM12.0201 3.672C9.13011 3.672 6.77011 6.022 6.77011 8.922V11.812C6.77011 12.542 6.47011 13.622 6.10011 14.252L4.95011 16.162C4.73011 16.532 4.67011 16.922 4.80011 17.252C4.92011 17.592 5.22011 17.852 5.63011 17.992C9.77852 19.3919 14.2717 19.3919 18.4201 17.992C18.7801 17.872 19.0601 17.602 19.1901 17.242C19.3201 16.882 19.2901 16.492 19.0901 16.162L17.9401 14.252C17.5601 13.602 17.2701 12.532 17.2701 11.802V8.922C17.2701 6.022 14.9201 3.672 12.0201 3.672Z"
        fill={color}
      />
      <path
        d="M13.88 3.94C13.81 3.94 13.74 3.93 13.67 3.91C13.38 3.83 13.1 3.77 12.83 3.73C11.98 3.62 11.16 3.68 10.39 3.91C10.11 4 9.81002 3.91 9.62002 3.7C9.52535 3.59651 9.46195 3.4683 9.43717 3.33025C9.41239 3.1922 9.42725 3.04995 9.48002 2.92C9.67912 2.40603 10.0295 1.96456 10.4847 1.65389C10.94 1.34323 11.4788 1.17799 12.03 1.18C13.17 1.18 14.17 1.86 14.58 2.92C14.68 3.19 14.63 3.49 14.44 3.7C14.29 3.86 14.08 3.94 13.88 3.94ZM12.02 22.809C11.03 22.809 10.07 22.409 9.37002 21.709C8.67002 21.009 8.27002 20.049 8.27002 19.059H9.77002C9.77002 19.649 10.01 20.229 10.43 20.649C10.85 21.069 11.43 21.309 12.02 21.309C13.26 21.309 14.27 20.299 14.27 19.059H15.77C15.77 21.129 14.09 22.809 12.02 22.809Z"
        fill={color}
      />
    </>
  );

  return <SwiftIcon color="none" size={size} path={path} />;
}

export function Trash({ color = ICON_COLORS["SWIFT_COLOR1"], size }) {
  const path = (
    <>
      <path
        d="M21 6.73h-.08c-5.29-.53-10.57-.73-15.8-.2l-2.04.2a.755.755 0 0 1-.83-.68c-.04-.42.26-.78.67-.82l2.04-.2c5.32-.54 10.71-.33 16.11.2.41.04.71.41.67.82a.74.74 0 0 1-.74.68Z"
        fill={color}
      ></path>
      <path
        d="M8.5 5.72c-.04 0-.08 0-.13-.01a.753.753 0 0 1-.61-.86l.22-1.31c.16-.96.38-2.29 2.71-2.29h2.62c2.34 0 2.56 1.38 2.71 2.3l.22 1.3c.07.41-.21.8-.61.86-.41.07-.8-.21-.86-.61l-.22-1.3c-.14-.87-.17-1.04-1.23-1.04H10.7c-1.06 0-1.08.14-1.23 1.03l-.23 1.3a.75.75 0 0 1-.74.63ZM15.21 22.752H8.79c-3.49 0-3.63-1.93-3.74-3.49L4.4 9.192c-.03-.41.29-.77.7-.8.42-.02.77.29.8.7l.65 10.07c.11 1.52.15 2.09 2.24 2.09h6.42c2.1 0 2.14-.57 2.24-2.09l.65-10.07c.03-.41.39-.72.8-.7.41.03.73.38.7.8l-.65 10.07c-.11 1.56-.25 3.49-3.74 3.49Z"
        fill={color}
      ></path>
      <path
        d="M13.66 17.25h-3.33c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h3.33c.41 0 .75.34.75.75s-.34.75-.75.75ZM14.5 13.25h-5c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h5c.41 0 .75.34.75.75s-.34.75-.75.75Z"
        fill={color}
      ></path>
    </>
  );

  return <SwiftIcon color="none" size={size} path={path} />;
}

export function ArrowLeft({ color = ICON_COLORS["SWIFT_COLOR1"], size }) {
  const path = (
    <>
      <path
        d="M9.57 5.92999L3.5 12L9.57 18.07M20.5 12H3.67"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  );

  return <SwiftIcon color="none" size={size} path={path} />;
}

export function ArrowLeft2({ color = ICON_COLORS["SWIFT_COLOR1"], size }) {
  const path = (
    <>
      <path
        d="M15 19.92L8.47997 13.4C7.70997 12.63 7.70997 11.37 8.47997 10.6L15 4.07999"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  );

  return <SwiftIcon color="none" size={size} path={path} />;
}

export function InfoCircle({ color = ICON_COLORS["SWIFT_COLOR1"], size }) {
  const path = (
    <>
      <path
        d="M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 8V13"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.9945 16H12.0035"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  );

  return <SwiftIcon color="none" size={size} path={path} />;
}

export function ReOrder({ color = ICON_COLORS["SWIFT_COLOR1"], size }) {
  const path = (
    <>
      <path
        d="M3 7H21"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M3 12H21"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M3 17H21"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </>
  );

  return <SwiftIcon color="none" size={size} path={path} />;
}

export function Settings({ color = ICON_COLORS["SWIFT_COLOR1"], size }) {
  const path = (
    <>
      <path
        d="M12 15.75C9.93 15.75 8.25 14.07 8.25 12C8.25 9.93 9.93 8.25 12 8.25C14.07 8.25 15.75 9.93 15.75 12C15.75 14.07 14.07 15.75 12 15.75ZM12 9.75C10.76 9.75 9.75 10.76 9.75 12C9.75 13.24 10.76 14.25 12 14.25C13.24 14.25 14.25 13.24 14.25 12C14.25 10.76 13.24 9.75 12 9.75Z"
        fill={color}
      />
      <path
        d="M15.21 22.19C15 22.19 14.79 22.16 14.58 22.11C13.96 21.94 13.44 21.55 13.11 21L12.99 20.8C12.4 19.78 11.59 19.78 11 20.8L10.89 20.99C10.56 21.55 10.04 21.95 9.42 22.11C8.79 22.28 8.14 22.19 7.59 21.86L5.87 20.87C5.26 20.52 4.82 19.95 4.63 19.26C4.45 18.57 4.54 17.86 4.89 17.25C5.18 16.74 5.26 16.28 5.09 15.99C4.92 15.7 4.49 15.53 3.9 15.53C2.44 15.53 1.25 14.34 1.25 12.88V11.12C1.25 9.66004 2.44 8.47004 3.9 8.47004C4.49 8.47004 4.92 8.30004 5.09 8.01004C5.26 7.72004 5.19 7.26004 4.89 6.75004C4.54 6.14004 4.45 5.42004 4.63 4.74004C4.81 4.05004 5.25 3.48004 5.87 3.13004L7.6 2.14004C8.73 1.47004 10.22 1.86004 10.9 3.01004L11.02 3.21004C11.61 4.23004 12.42 4.23004 13.01 3.21004L13.12 3.02004C13.8 1.86004 15.29 1.47004 16.43 2.15004L18.15 3.14004C18.76 3.49004 19.2 4.06004 19.39 4.75004C19.57 5.44004 19.48 6.15004 19.13 6.76004C18.84 7.27004 18.76 7.73004 18.93 8.02004C19.1 8.31004 19.53 8.48004 20.12 8.48004C21.58 8.48004 22.77 9.67004 22.77 11.13V12.89C22.77 14.35 21.58 15.54 20.12 15.54C19.53 15.54 19.1 15.71 18.93 16C18.76 16.29 18.83 16.75 19.13 17.26C19.48 17.87 19.58 18.59 19.39 19.27C19.21 19.96 18.77 20.53 18.15 20.88L16.42 21.87C16.04 22.08 15.63 22.19 15.21 22.19ZM12 18.49C12.89 18.49 13.72 19.05 14.29 20.04L14.4 20.23C14.52 20.44 14.72 20.59 14.96 20.65C15.2 20.71 15.44 20.68 15.64 20.56L17.37 19.56C17.63 19.41 17.83 19.16 17.91 18.86C17.99 18.56 17.95 18.25 17.8 17.99C17.23 17.01 17.16 16 17.6 15.23C18.04 14.46 18.95 14.02 20.09 14.02C20.73 14.02 21.24 13.51 21.24 12.87V11.11C21.24 10.48 20.73 9.96004 20.09 9.96004C18.95 9.96004 18.04 9.52004 17.6 8.75004C17.16 7.98004 17.23 6.97004 17.8 5.99004C17.95 5.73004 17.99 5.42004 17.91 5.12004C17.83 4.82004 17.64 4.58004 17.38 4.42004L15.65 3.43004C15.22 3.17004 14.65 3.32004 14.39 3.76004L14.28 3.95004C13.71 4.94004 12.88 5.50004 11.99 5.50004C11.1 5.50004 10.27 4.94004 9.7 3.95004L9.59 3.75004C9.34 3.33004 8.78 3.18004 8.35 3.43004L6.62 4.43004C6.36 4.58004 6.16 4.83004 6.08 5.13004C6 5.43004 6.04 5.74004 6.19 6.00004C6.76 6.98004 6.83 7.99004 6.39 8.76004C5.95 9.53004 5.04 9.97004 3.9 9.97004C3.26 9.97004 2.75 10.48 2.75 11.12V12.88C2.75 13.51 3.26 14.03 3.9 14.03C5.04 14.03 5.95 14.47 6.39 15.24C6.83 16.01 6.76 17.02 6.19 18C6.04 18.26 6 18.57 6.08 18.87C6.16 19.17 6.35 19.41 6.61 19.57L8.34 20.56C8.55 20.69 8.8 20.72 9.03 20.66C9.27 20.6 9.47 20.44 9.6 20.23L9.71 20.04C10.28 19.06 11.11 18.49 12 18.49Z"
        fill={color}
      />
    </>
  );

  return <SwiftIcon color="none" size={size} path={path} />;
}

export function ProfileUser({ color = ICON_COLORS["SWIFT_COLOR1"], size }) {
  const path = (
    <>
      <path
        d="M9.15957 11.62C9.12957 11.62 9.10957 11.62 9.07957 11.62C9.02957 11.61 8.95957 11.61 8.89957 11.62C5.99957 11.53 3.80957 9.25 3.80957 6.44C3.80957 3.58 6.13957 1.25 8.99957 1.25C11.8596 1.25 14.1896 3.58 14.1896 6.44C14.1796 9.25 11.9796 11.53 9.18957 11.62C9.17957 11.62 9.16957 11.62 9.15957 11.62ZM8.99957 2.75C6.96957 2.75 5.30957 4.41 5.30957 6.44C5.30957 8.44 6.86957 10.05 8.85957 10.12C8.91957 10.11 9.04957 10.11 9.17957 10.12C11.1396 10.03 12.6796 8.42 12.6896 6.44C12.6896 4.41 11.0296 2.75 8.99957 2.75Z"
        fill={color}
      />
      <path
        d="M16.5396 11.75C16.5096 11.75 16.4796 11.75 16.4496 11.74C16.0396 11.78 15.6196 11.49 15.5796 11.08C15.5396 10.67 15.7896 10.3 16.1996 10.25C16.3196 10.24 16.4496 10.24 16.5596 10.24C18.0196 10.16 19.1596 8.96 19.1596 7.49C19.1596 5.97 17.9296 4.74 16.4096 4.74C15.9996 4.75 15.6596 4.41 15.6596 4C15.6596 3.59 15.9996 3.25 16.4096 3.25C18.7496 3.25 20.6596 5.16 20.6596 7.5C20.6596 9.8 18.8596 11.66 16.5696 11.75C16.5596 11.75 16.5496 11.75 16.5396 11.75Z"
        fill={color}
      />
      <path
        d="M9.16961 22.55C7.20961 22.55 5.23961 22.05 3.74961 21.05C2.35961 20.13 1.59961 18.87 1.59961 17.5C1.59961 16.13 2.35961 14.86 3.74961 13.93C6.74961 11.94 11.6096 11.94 14.5896 13.93C15.9696 14.85 16.7396 16.11 16.7396 17.48C16.7396 18.85 15.9796 20.12 14.5896 21.05C13.0896 22.05 11.1296 22.55 9.16961 22.55ZM4.57961 15.19C3.61961 15.83 3.09961 16.65 3.09961 17.51C3.09961 18.36 3.62961 19.18 4.57961 19.81C7.06961 21.48 11.2696 21.48 13.7596 19.81C14.7196 19.17 15.2396 18.35 15.2396 17.49C15.2396 16.64 14.7096 15.82 13.7596 15.19C11.2696 13.53 7.06961 13.53 4.57961 15.19Z"
        fill={color}
      />
      <path
        d="M18.3396 20.75C17.9896 20.75 17.6796 20.51 17.6096 20.15C17.5296 19.74 17.7896 19.35 18.1896 19.26C18.8196 19.13 19.3996 18.88 19.8496 18.53C20.4196 18.1 20.7296 17.56 20.7296 16.99C20.7296 16.42 20.4196 15.88 19.8596 15.46C19.4196 15.12 18.8696 14.88 18.2196 14.73C17.8196 14.64 17.5596 14.24 17.6496 13.83C17.7396 13.43 18.1396 13.17 18.5496 13.26C19.4096 13.45 20.1596 13.79 20.7696 14.26C21.6996 14.96 22.2296 15.95 22.2296 16.99C22.2296 18.03 21.6896 19.02 20.7596 19.73C20.1396 20.21 19.3596 20.56 18.4996 20.73C18.4396 20.75 18.3896 20.75 18.3396 20.75Z"
        fill={color}
      />
    </>
  );

  return <SwiftIcon color="none" size={size} path={path} />;
}

export function HomeHashtag({ color = ICON_COLORS["SWIFT_COLOR1"], size }) {
  const path = (
    <>
      <path
        d="M9.02 2.83992L3.63 7.03992C2.73 7.73992 2 9.22992 2 10.3599V17.7699C2 20.0899 3.89 21.9899 6.21 21.9899H17.79C20.11 21.9899 22 20.0899 22 17.7799V10.4999C22 9.28992 21.19 7.73992 20.2 7.04992L14.02 2.71992C12.62 1.73992 10.37 1.78992 9.02 2.83992Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.5 18H13.5C15.15 18 16.5 16.65 16.5 15V12C16.5 10.35 15.15 9 13.5 9H10.5C8.85 9 7.5 10.35 7.5 12V15C7.5 16.65 8.85 18 10.5 18Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 9V18"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 13.5H16.5"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  );

  return <SwiftIcon color="none" size={size} path={path} />;
}

export function BoxAdd({ color = ICON_COLORS["SWIFT_COLOR1"], size }) {
  const path = (
    <>
      <path
        d="M19.0002 22.75C17.6002 22.75 16.2902 22.14 15.3902 21.07C15.3802 21.05 15.3202 21 15.2702 20.92C15.1602 20.81 15.0302 20.61 14.9202 20.42C14.4802 19.71 14.2402 18.87 14.2402 17.99C14.2402 16.53 14.8902 15.18 16.0202 14.28C16.8602 13.61 17.9202 13.24 18.9902 13.24C20.1502 13.24 21.2202 13.64 22.0802 14.39C22.2002 14.47 22.3402 14.62 22.4702 14.76C23.2802 15.65 23.7302 16.79 23.7302 17.98C23.7302 18.85 23.4902 19.7 23.0402 20.43C22.8002 20.85 22.4702 21.23 22.0902 21.55C21.2802 22.33 20.1702 22.75 19.0002 22.75ZM19.0002 14.75C18.2602 14.75 17.5602 15 16.9702 15.47C16.2002 16.08 15.7502 17.01 15.7502 18C15.7502 18.59 15.9102 19.17 16.2202 19.67C16.3002 19.81 16.3802 19.92 16.4702 20.03C16.4902 20.05 16.5502 20.11 16.6002 20.19C17.1502 20.84 18.0502 21.26 19.0002 21.26C19.7902 21.26 20.5502 20.97 21.1302 20.45C21.3902 20.23 21.6102 19.97 21.7702 19.69C22.0902 19.18 22.2502 18.6 22.2502 18.01C22.2502 17.2 21.9402 16.41 21.3802 15.8C21.3102 15.72 21.2302 15.64 21.1502 15.58C20.5202 15.02 19.7902 14.75 19.0002 14.75Z"
        fill={color}
      />
      <path
        d="M20.49 18.73H17.5C17.09 18.73 16.75 18.39 16.75 17.98C16.75 17.57 17.09 17.23 17.5 17.23H20.49C20.9 17.23 21.24 17.57 21.24 17.98C21.24 18.39 20.91 18.73 20.49 18.73Z"
        fill={color}
      />
      <path
        d="M19 20.26C18.59 20.26 18.25 19.92 18.25 19.51V16.52C18.25 16.11 18.59 15.77 19 15.77C19.41 15.77 19.75 16.11 19.75 16.52V19.51C19.75 19.93 19.41 20.26 19 20.26Z"
        fill={color}
      />
      <path
        d="M11.9998 13.2999C11.8698 13.2999 11.7398 13.2699 11.6198 13.1999L2.78983 8.0899C2.42983 7.8799 2.30984 7.41987 2.51984 7.05987C2.72984 6.69987 3.18983 6.57985 3.53983 6.78985L11.9898 11.6799L20.3898 6.81988C20.7498 6.60988 21.2098 6.7399 21.4098 7.0899C21.6198 7.4499 21.4898 7.90987 21.1398 8.11987L12.3698 13.1999C12.2598 13.2599 12.1298 13.2999 11.9998 13.2999Z"
        fill={color}
      />
      <path
        d="M12 22.3598C11.59 22.3598 11.25 22.0198 11.25 21.6098V12.5398C11.25 12.1298 11.59 11.7898 12 11.7898C12.41 11.7898 12.75 12.1298 12.75 12.5398V21.6098C12.75 22.0198 12.41 22.3598 12 22.3598Z"
        fill={color}
      />
      <path
        d="M11.9999 22.7499C11.1199 22.7499 10.2399 22.5599 9.55988 22.1699L4.21988 19.2099C2.76988 18.4099 1.62988 16.4799 1.62988 14.8199V9.1599C1.62988 7.4999 2.76988 5.57994 4.21988 4.76994L9.55988 1.80992C10.9199 1.03992 13.0599 1.03992 14.4299 1.80992L19.7699 4.76994C21.2199 5.56994 22.3599 7.4999 22.3599 9.1599V14.8199C22.3599 14.9199 22.3599 14.9999 22.3399 15.0999C22.2899 15.3599 22.0999 15.5799 21.8499 15.6599C21.5999 15.7499 21.3199 15.6899 21.1099 15.5199C19.9599 14.5199 18.1799 14.4799 16.9699 15.4499C16.1999 16.0599 15.7499 16.9899 15.7499 17.9799C15.7499 18.5699 15.9099 19.1499 16.2199 19.6499C16.2999 19.7899 16.3799 19.8999 16.4699 20.0099C16.6199 20.1799 16.6799 20.4099 16.6399 20.6299C16.5999 20.8499 16.4599 21.0399 16.2599 21.1499L14.4299 22.1599C13.7499 22.5599 12.8799 22.7499 11.9999 22.7499ZM11.9999 2.74992C11.3799 2.74992 10.7499 2.87993 10.2999 3.12993L4.95988 6.08995C3.98988 6.61995 3.14987 8.0599 3.14987 9.1599V14.8199C3.14987 15.9199 3.99988 17.3599 4.95988 17.8899L10.2999 20.8499C11.2099 21.3599 12.7999 21.3599 13.7099 20.8499L14.8299 20.2299C14.4599 19.5599 14.2599 18.7799 14.2599 17.9799C14.2599 16.5199 14.9099 15.1699 16.0399 14.2699C17.3999 13.1799 19.3499 12.9499 20.8699 13.5999V9.13994C20.8699 8.03994 20.0199 6.59993 19.0599 6.06993L13.7199 3.10991C13.2499 2.87991 12.6199 2.74992 11.9999 2.74992Z"
        fill={color}
      />
    </>
  );

  return <SwiftIcon color="none" size={size} path={path} />;
}

export function More({ color = ICON_COLORS["SWIFT_COLOR1"], size }) {
  const path = (
    <>
      <path
        d="M5 10C3.9 10 3 10.9 3 12C3 13.1 3.9 14 5 14C6.1 14 7 13.1 7 12C7 10.9 6.1 10 5 10Z"
        stroke={color}
        strokeWidth="1.5"
      />
      <path
        d="M19 10C17.9 10 17 10.9 17 12C17 13.1 17.9 14 19 14C20.1 14 21 13.1 21 12C21 10.9 20.1 10 19 10Z"
        stroke={color}
        strokeWidth="1.5"
      />
      <path
        d="M12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10Z"
        stroke={color}
        strokeWidth="1.5"
      />
    </>
  );

  return <SwiftIcon color="none" size={size} path={path} />;
}

export function LogOut({ color = ICON_COLORS["SWIFT_COLOR1"], size }) {
  const path = (
    <>
      <path
        d="M6.85791 6.85791C3.54591 10.1699 3.54591 15.5459 6.85791 18.8579C10.1699 22.1699 15.5459 22.1699 18.8579 18.8579C22.1699 15.5459 22.1699 10.1699 18.8579 6.85791"
        stroke={color}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.8319 14.2034L12.8319 4.36345"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  );

  return <SwiftIcon color="none" size={size} path={path} />;
}

export function Sun({ color = ICON_COLORS["SWIFT_COLOR1"], size }) {
  const path = (
    <>
      <circle cx="12" cy="12" r="4" stroke={color} strokeWidth="1.5" />
      <path d="M12 2v2" stroke={color} strokeWidth="1.5" />
      <path d="M12 20v2" stroke={color} strokeWidth="1.5" />
      <path d="m4.93 4.93 1.41 1.41" stroke={color} strokeWidth="1.5" />
      <path d="m17.66 17.66 1.41 1.41" stroke={color} strokeWidth="1.5" />
      <path d="M2 12h2" stroke={color} strokeWidth="1.5" />
      <path d="M20 12h2" stroke={color} strokeWidth="1.5" />
      <path d="m6.34 17.66-1.41 1.41" stroke={color} strokeWidth="1.5" />
      <path d="m19.07 4.93-1.41 1.41" stroke={color} strokeWidth="1.5" />
    </>
  );

  return <SwiftIcon color="none" size={size} path={path} />;
}

export function Moon({ color = ICON_COLORS["SWIFT_COLOR1"], size }) {
  const path = (
    <>
      <path
        d="M20.985 12.486a9 9 0 1 1-9.473-9.472c.405-.022.617.46.402.803a6 6 0 0 0 8.268 8.268c.344-.215.825-.004.803.401"
        stroke={color}
        strokeWidth="1.5"
      />
    </>
  );

  return <SwiftIcon color="none" size={size} path={path} />;
}

export function MaxiMize({ color = ICON_COLORS["SWIFT_COLOR1"], size }) {
  const path = (
    <>
      <path
        d="M2 9V6.5C2 4.01 4.01 2 6.5 2H9"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 2H17.5C19.99 2 22 4.01 22 6.5V9"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22 16V17.5C22 19.99 19.99 22 17.5 22H16"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 22H6.5C4.01 22 2 19.99 2 17.5V15"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  );

  return <SwiftIcon color="none" size={size} path={path} />;
}

export function TaskSquare({ color = ICON_COLORS["SWIFT_COLOR1"], size }) {
  const path = (
    <>
      <path
        d="M12.3701 8.87988H17.6201"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.37988 8.87988L7.12988 9.62988L9.37988 7.37988"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.3701 15.8799H17.6201"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.37988 15.8799L7.12988 16.6299L9.37988 14.3799"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  );

  return <SwiftIcon color="none" size={size} path={path} />;
}

export function CustomerIcon({ color = ICON_COLORS["SWIFT_COLOR1"], size }) {
  const path = (
    <g transform="scale(0.1875)">
      <path
        stroke={color}
        strokeLinecap="round"
        strokeWidth="4"
        d="M63.5 69C41.0316 69 22.5418 86.0747 20.241 107.985C19.9684 110.581 22.0082 112.759 24.6107 112.963L39.2051 114.102C55.377 115.366 71.6229 115.366 87.7949 114.102L102.389 112.963C104.992 112.759 107.032 110.581 106.759 107.985C104.458 86.0747 85.9684 69 63.5 69Z"
      />
      <circle cx="64" cy="47" r="22" stroke={color} strokeWidth="4" />
      <path
        stroke={color}
        strokeWidth="4"
        d="M98 47C98 27.67 82.7777 12 64 12C45.2223 12 30 27.67 30 47"
      />
      <path
        stroke={color}
        strokeWidth="4"
        d="M88 50.9507C88 47.8643 90.7688 45.4568 93.814 45.9593L98 46.65V51C98 53.7614 95.7614 56 93 56C90.2386 56 88 53.7121 88 50.9507zM40 50.6359C40 47.6383 37.3805 45.3143 34.4043 45.6715L30 46.2V52C30 54.7614 32.2386 57 35 57C37.7614 57 40 54.7614 40 52V50.6359z"
      />
      <path
        stroke={color}
        strokeWidth="4"
        strokeLinecap="round"
        d="M94 56L70 56"
      />
      <rect
        width="6"
        height="3"
        x="67"
        y="53"
        fill={color}
        stroke={color}
        strokeWidth="4"
        rx="1.5"
      />
    </g>
  );

  return <SwiftIcon color="none" size={size} path={path} />;
}

export function ManagerIcon({ color = ICON_COLORS["SWIFT_COLOR1"], size }) {
  const path = (
    <g transform="scale(0.375)">
      <path d="M58,63.5H6c-0.5,0-1-0.4-1-1V47.2c0-4.1,2.4-7.8,6.2-9.5C15,36,18.8,34.8,22.5,34c0.4-0.1,0.9,0.1,1.1,0.5L32,52.3l8.4-17.7c0.2-0.4,0.6-0.6,1.1-0.5c3.7,0.8,7.5,2,11.3,3.7c3.8,1.7,6.2,5.4,6.2,9.5v15.3C59,63.1,58.5,63.5,58,63.5z M6.9,61.6h50.1V47.2c0-3.3-2-6.4-5.1-7.8c-3.4-1.5-6.8-2.7-10.1-3.4l-9,18.8c-0.2,0.3-0.5,0.5-0.9,0.5c-0.4,0-0.7-0.2-0.9-0.5l-9-18.8c-3.3,0.7-6.8,1.9-10.1,3.4c-3.1,1.4-5.1,4.4-5.1,7.8V61.6z" />
      <path d="M34.2,39.8h-4.5c-0.4,0-0.8-0.3-0.9-0.7l-1-4.2c-0.1-0.3,0-0.6,0.2-0.8c0.2-0.2,0.5-0.4,0.8-0.4h6.5c0.3,0,0.6,0.1,0.8,0.4c0.2,0.2,0.2,0.5,0.2,0.8l-1,4.2C35.1,39.5,34.7,39.8,34.2,39.8z M30.5,37.9h3l0.6-2.3h-4.1L30.5,37.9z" />
      <path d="M35.4 48.3c-.5 0-.9-.4-1-.9L33.3 39c-.1-.5.3-1 .8-1.1.5-.1 1 .3 1.1.8l1.2 8.4c0 0 0 .1 0 .1C36.4 47.8 36 48.3 35.4 48.3zM28.6 48.3c-.5 0-1-.4-1-1v0c0 0 0-.1 0-.1l1.2-8.4c.1-.5.6-.9 1.1-.8.5.1.9.6.8 1.1l-1.2 8.4C29.5 47.9 29.1 48.3 28.6 48.3zM48.4 63.5c-.5 0-1-.4-1-1V51c0-.5.4-1 1-1 .5 0 1 .4 1 1v11.6C49.4 63.1 48.9 63.5 48.4 63.5zM15.6 63.5c-.5 0-1-.4-1-1V51c0-.5.4-1 1-1 .5 0 1 .4 1 1v11.6C16.5 63.1 16.1 63.5 15.6 63.5z" />
      <g>
        <path d="M32,31.9c-6.6,0-13-8.9-13-18.1c0-8.1,5.1-13.4,13-13.4c7.9,0,13,5.2,13,13.4C45,23,38.6,31.9,32,31.9z M32,2.4c-5.4,0-11.1,3-11.1,11.4c0,8,5.6,16.2,11.1,16.2c5.5,0,11.1-8.2,11.1-16.2C43.1,5.4,37.4,2.4,32,2.4z" />
        <path d="M35.7,13.2c-1.7,0-3.2-0.3-4.5-1c-1.3-0.6-2.2-1.5-2.8-2.1c-1.7,1.9-4.8,3.3-8.5,2.8c-0.5-0.1-0.9-0.5-0.8-1.1c0.1-0.5,0.6-0.9,1.1-0.8c3.8,0.5,6.6-1.4,7.4-3c0.2-0.3,0.5-0.5,0.9-0.5c0.4,0,0.7,0.2,0.9,0.6c0.1,0.3,3.2,6.3,13.9,1.3c0.5-0.2,1,0,1.3,0.5c0.2,0.5,0,1-0.5,1.3C41,12.5,38.2,13.2,35.7,13.2z" />
      </g>
    </g>
  );

  return <SwiftIcon color={color} size={size} path={path} />;
}

export function UnlistIcon({ size, color = "#757575" }) {
  const path = (
    <>
      <path d="M21,13a1,1,0,0,0-1,1v3a3,3,0,0,1-3,3H7a3,3,0,0,1-3-3V7A3,3,0,0,1,7,4h3a1,1,0,0,0,0-2H7A5.006,5.006,0,0,0,2,7V17a5.006,5.006,0,0,0,5,5H17a5.006,5.006,0,0,0,5-5V14A1,1,0,0,0,21,13Z" />
      <path d="M21,2H13a1,1,0,0,0-1,1V4a1,1,0,0,0,.293.707l1.379,1.38L8.1,13.344a1.831,1.831,0,0,0,1.483,2.9,1.9,1.9,0,0,0,1.1-.36l7.229-5.555,1.379,1.38A1,1,0,0,0,20,12h1a1,1,0,0,0,1-1V3A1,1,0,0,0,21,2ZM20,9.586L18.707,8.293a1,1,0,0,0-1.316-.086l-6.9,5.3,5.3-6.9a1,1,0,0,0-.086-1.316L14.414,4H20V9.586Z" />
    </>
  );

  return <SwiftIcon size={size} color={color} path={path} />;
}

export function AiResearch({ size, color = '#757575' }) {
  const path = (
    <>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color={color} fill="none" stroke={color} stroke-width="1.5" stroke-linejoin="round">
        <path d="M4 12C4 8.22876 4 6.34315 5.17157 5.17157C6.34315 4 8.22876 4 12 4C15.7712 4 17.6569 4 18.8284 5.17157C20 6.34315 20 8.22876 20 12C20 15.7712 20 17.6569 18.8284 18.8284C17.6569 20 15.7712 20 12 20C8.22876 20 6.34315 20 5.17157 18.8284C4 17.6569 4 15.7712 4 12Z" />
        <path d="M7.5 15L9.34189 9.47434C9.43631 9.19107 9.7014 9 10 9C10.2986 9 10.5637 9.19107 10.6581 9.47434L12.5 15M8.5 13H11.5" />
        <path d="M15.5 9V15" />
        <path d="M8 2V4M16 2V4M12 2V4M8 20V22M12 20V22M16 20V22M22 16H20M4 8H2M4 16H2M4 12H2M22 8H20M22 12H20" />
      </svg>
    </>
  );

  return <SwiftIcon size={size} color={color} path={path} />;
}

export function Portfolio({ color = ICON_COLORS["SWIFT_COLOR1"], size }) {
  const path = (
    <path
      d="M61.568 17H46.501v-6.785C46.501 6.556 43.849 4 39.866 4h-8.138C27.615 4 25.5 6.613 25.5 10.214V17H10.432A6.933 6.933 0 0 0 3.5 23.932v37.136a6.934 6.934 0 0 0 6.932 6.933h51.136a6.933 6.933 0 0 0 6.932-6.933h.001V23.932A6.933 6.933 0 0 0 61.568 17zM29.5 10.215C29.5 8.063 31.41 8 31.727 8h7.136c1.263 0 3.637.384 3.637 2.214V17h-13v-6.785zM61.568 64H10.432A2.932 2.932 0 0 1 7.5 61.068V43h3.13a1 1 0 1 0 0-2H7.5V23.932A2.932 2.932 0 0 1 10.432 21h51.136a2.932 2.932 0 0 1 2.932 2.932h.001V41H42.499v-.93a4.069 4.069 0 0 0-4.069-4.069h-4.86a4.069 4.069 0 0 0-4.07 4.069V41H16.631a1 1 0 1 0 0 2H29.5v1.93A4.07 4.07 0 0 0 33.57 49h4.86a4.07 4.07 0 0 0 4.07-4.07h-.001V43h22.002v18.068A2.932 2.932 0 0 1 61.568 64zM40.5 40.07l-.001 4.859a2.07 2.07 0 0 1-2.069 2.07h-4.86a2.07 2.07 0 0 1-2.07-2.07V40.07c0-1.143.926-2.069 2.07-2.069h4.86c1.143 0 2.07.925 2.07 2.069z"
      fill={color}
      stroke={color}
      strokeWidth="0.8"
    />
  );

  return <SwiftIcon size={size} color="none" path={path} viewBox="0 0 72 72" />;
}

export function SIP({ color = ICON_COLORS["SWIFT_COLOR1"], size }) {
  const path = (
    <>
      <path
        fill={color}
        stroke={color}
        strokeWidth="0.8"
        d="M160.033 23.952c-5.912-.028-31.785.019-33.401 0-2.713-.037-5.062 2.304-5.02 5.019-.062.721.045 23.553 0 30.875-.002 2.885.005 4.749-.003 4.754-.007.006-1.927 0-4.778.003-5.804-.004-23.097.003-23.588 0-2.711-.045-5.071 2.309-5.024 5.023.005 1.751-.004 23.137 0 28.762-3.119.175-13.224.022-18.04.071-5.406 0-10.004 0-10.313 0-2.542-.021-4.822 1.998-5.001 4.592-.219 8.941.28 35.568-.177 36.059-7.631.03-20.101-.022-27.461 0-4.319-.536-7.467 4.338-4.81 7.949 1.15 1.616 3.124 2.218 5.116 2.051 3.441-.018 6.769.013 11.018 0 9.362 0 20.815 0 21.272 0 2.712.038 5.063-2.305 5.02-5.019.046-.568-.033-22.092 0-29.314.002-3.753-.005-6.31.003-6.315 5.227-.002 27.02-.004 28.35-.003 2.71.045 5.072-2.31 5.024-5.023-.022-1.61.016-23.235 0-28.81 4.096-.064 26.748-.001 28.37-.023 2.704.05 5.073-2.311 5.024-5.018-.135-1.216.098-27.108 0-35.091-.007-.27.002-.419.004-.539.005-.006 16.419 0 24.283-.003h4.084c.975.024 2.177-.362 2.973-.969 3.831-2.674 1.799-9.071-2.844-9.027l-.079-.003ZM55.564 61.137c.168 5.694 8.219 6.685 9.795 1.285.148-.518.211-1.108.202-1.515.019-3.984-.013-8.506 0-15.354 0-9.325 0-19.441 0-19.656 0-.018-.001-.09-.011-.245-.093-1.709-1.035-3.254-2.535-4.098-.705-.425-1.668-.644-2.488-.665-.025 0-1.852 0-4.703 0-9.491.005-29.199-.008-30.007.003-4.118-.022-6.446 5.236-3.689 8.248.897 1.086 2.387 1.76 3.821 1.75.627 0 15.513 0 20.806 0 1.376.043 2.105-.094 1.786.07-2.942 2.981-5.871 5.959-10.99 11.149-12.37 12.548-30.742 31.186-31.107 31.556-2.131 2.116-1.856 5.859.663 7.592 1.812 1.299 4.373 1.241 6.146-.286 1.267-1.2 1.985-2.005 3.536-3.554 11.096-11.254 28.189-28.597 38.682-39.24.261.701 0 19.334.091 22.879l.003.08Z"
      />
    </>
  );

  return (
    <SwiftIcon size={size} color="none" path={path} viewBox="0 0 170 170" />
  );
}

export function Transactions({ color = ICON_COLORS["SWIFT_COLOR1"], size }) {
  const path = (
    <>
      <path
        fill={color}
        fill-rule="evenodd"
        d="M14.0564 3.25H9.94358C8.10584 3.24999 6.65019 3.24997 5.51098 3.40314C4.33856 3.56076 3.38961 3.89288 2.64124 4.64124C1.89288 5.38961 1.56076 6.33856 1.40314 7.51098C1.24997 8.65019 1.24999 10.1058 1.25 11.9436V12.0564C1.24999 13.8942 1.24997 15.3498 1.40314 16.489C1.56076 17.6614 1.89288 18.6104 2.64124 19.3588C3.38961 20.1071 4.33856 20.4392 5.51098 20.5969C6.65018 20.75 8.10585 20.75 9.94359 20.75H14C14.4142 20.75 14.75 20.4142 14.75 20C14.75 19.5858 14.4142 19.25 14 19.25H10C8.09318 19.25 6.73851 19.2484 5.71085 19.1102C4.70476 18.975 4.12511 18.7213 3.7019 18.2981C3.27869 17.8749 3.02503 17.2952 2.88976 16.2892C2.75159 15.2615 2.75 13.9068 2.75 12C2.75 11.3567 2.75018 10.7763 2.75573 10.25H21.2443C21.2498 10.7763 21.25 11.3567 21.25 12V15C21.25 15.4142 21.5858 15.75 22 15.75C22.4142 15.75 22.75 15.4142 22.75 15V11.9435C22.75 10.1058 22.75 8.65018 22.5969 7.51098C22.4392 6.33856 22.1071 5.38961 21.3588 4.64124C20.6104 3.89288 19.6614 3.56076 18.489 3.40314C17.3498 3.24997 15.8942 3.24999 14.0564 3.25ZM21.2024 8.75C21.1819 8.36886 21.1524 8.02461 21.1102 7.71085C20.975 6.70476 20.7213 6.12511 20.2981 5.7019C19.8749 5.27869 19.2952 5.02503 18.2892 4.88976C17.2615 4.75159 15.9068 4.75 14 4.75H10C8.09318 4.75 6.73851 4.75159 5.71085 4.88976C4.70476 5.02503 4.12511 5.27869 3.7019 5.7019C3.27869 6.12511 3.02503 6.70476 2.88976 7.71085C2.84758 8.02461 2.81812 8.36886 2.79756 8.75H21.2024Z"
        clip-rule="evenodd"
      ></path>
      <path
        fill={color}
        d="M5.25 16C5.25 15.5858 5.58579 15.25 6 15.25H8C8.41421 15.25 8.75 15.5858 8.75 16 8.75 16.4142 8.41421 16.75 8 16.75H6C5.58579 16.75 5.25 16.4142 5.25 16ZM22.1103 18.4359C22.3511 18.0989 22.273 17.6305 21.9359 17.3897 21.5989 17.1489 21.1305 17.227 20.8897 17.5641L20.0337 18.7625C19.6754 19.2641 19.4451 19.5843 19.2483 19.7997 19.0611 20.0047 18.9807 20.0265 18.9535 20.0325 18.9047 20.0434 18.8546 20.0475 18.8046 20.0448 18.7768 20.0434 18.6939 20.0351 18.4755 19.8636 18.246 19.6836 17.9662 19.4055 17.5303 18.9697 17.2374 18.6768 16.7626 18.6768 16.4697 18.9697 16.1768 19.2626 16.1768 19.7374 16.4697 20.0303L16.5007 20.0614C16.8965 20.4572 17.2403 20.801 17.5495 21.0437 17.8777 21.3013 18.2547 21.5175 18.7243 21.5427 18.9104 21.5527 19.097 21.5372 19.279 21.4968 19.738 21.3947 20.0743 21.1195 20.3558 20.8114 20.6209 20.5212 20.9035 20.1255 21.2288 19.67L22.1103 18.4359Z"
      ></path>
    </>
  );

  return <SwiftIcon size={size} color="none" path={path} viewBox="0 0 24 24" />;
}

export function SIPTransaction({
  color = ICON_COLORS["SWIFT_COLOR1"],
  size,
}) {
  const path = (
    <>
      <path
        fill={color}
        d="M7.49998 1C7.77613 1 7.99998 1.22386 7.99998 1.5V2.42763C8.15702 2.4998 8.30415 2.60053 8.43355 2.72983L12.1458 6.43921C12.7319 7.02493 12.7321 7.97499 12.1462 8.56093L7.0781 13.629C6.48218 14.2249 5.51243 14.2131 4.93123 13.6028L1.31095 9.80152C.749447 9.21194.760786 8.28209 1.3365 7.70638L6.31263 2.73023C6.50977 2.53309 6.74814 2.4023 6.99998 2.33785V1.5C6.99998 1.22386 7.22384 1 7.49998 1zM6.99998 4.5V3.4571L2.45709 8H11.2929L11.4391 7.85383C11.6344 7.65851 11.6343 7.34182 11.4389 7.14658L7.99998 3.71027V4.5C7.99998 4.77614 7.77613 5 7.49998 5 7.22384 5 6.99998 4.77614 6.99998 4.5zM1.95461 9C1.97565 9.03992 2.00247 9.07761 2.03509 9.11187L5.65537 12.9132C5.8491 13.1166 6.17235 13.1205 6.37099 12.9219L10.2929 9H1.95461zM12.9211 10.222C12.6981 9.96719 12.3018 9.96719 12.0789 10.222L10.9285 11.5367C9.74705 12.8869 10.7059 15 12.5 15 14.2941 15 15.2529 12.8869 14.0715 11.5367L12.9211 10.222zM11.681 12.1952L12.5 11.2593 13.3189 12.1952C13.9346 12.8989 13.4349 14 12.5 14 11.5651 14 11.0654 12.8989 11.681 12.1952z"
      ></path>
    </>
  );

  return <SwiftIcon size={size} color="none" path={path} viewBox="0 0 16 16" />;
}

export function Search({ color = ICON_COLORS["SWIFT_COLOR1"], size }) {
  const path = (
    <>
      <path
        d="M3.624,15a8.03,8.03,0,0,0,10.619.659l5.318,5.318a1,1,0,0,0,1.414-1.414l-5.318-5.318A8.04,8.04,0,0,0,3.624,3.624,8.042,8.042,0,0,0,3.624,15Zm1.414-9.96a6.043,6.043,0,1,1-1.77,4.274A6,6,0,0,1,5.038,5.038Z"
        fill={color}
      />
    </>
  );

  return <SwiftIcon size={size} color="none" path={path} viewBox="0 0 24 24" />;
}

export function Card({ color = ICON_COLORS["SWIFT_COLOR1"], size }) {
  const path = (
    <>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color={color} fill="none" stroke={color} stroke-width="1.5" stroke-linejoin="round">
        <path d="M14 3.5C17.7712 3.5 19.6569 3.5 20.8284 4.7448C22 5.98959 22 7.99306 22 12C22 16.0069 22 18.0104 20.8284 19.2552C19.6569 20.5 17.7712 20.5 14 20.5L10 20.5C6.22876 20.5 4.34315 20.5 3.17157 19.2552C2 18.0104 2 16.0069 2 12C2 7.99306 2 5.98959 3.17157 4.7448C4.34315 3.5 6.22876 3.5 10 3.5L14 3.5Z" />
        <path d="M5 15.5C6.60865 13.3626 10.3539 13.246 12 15.5M10.249 10.2501C10.249 11.2166 9.46552 12.0001 8.49902 12.0001C7.53253 12.0001 6.74902 11.2166 6.74902 10.2501C6.74902 9.28362 7.53253 8.50012 8.49902 8.50012C9.46552 8.50012 10.249 9.28362 10.249 10.2501Z" />
        <path d="M15 9.5L19 9.5" />
        <path d="M15 13.5H17" />
      </svg>
    </>
  );

  return <SwiftIcon color="none" size={size} path={path} />;
}

export function Call({ color = ICON_COLORS["SWIFT_COLOR1"], size }) {
  const path = (
    <>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color={color} fill="none" stroke={color} stroke-width="1.5" stroke-linecap="round">
        <path d="M9.1585 5.71217L8.75584 4.80619C8.49256 4.21382 8.36092 3.91762 8.16405 3.69095C7.91732 3.40688 7.59571 3.19788 7.23592 3.08779C6.94883 2.99994 6.6247 2.99994 5.97645 2.99994C5.02815 2.99994 4.554 2.99994 4.15597 3.18223C3.68711 3.39696 3.26368 3.86322 3.09497 4.35054C2.95175 4.76423 2.99278 5.18937 3.07482 6.03964C3.94815 15.0901 8.91006 20.052 17.9605 20.9254C18.8108 21.0074 19.236 21.0484 19.6496 20.9052C20.137 20.7365 20.6032 20.3131 20.818 19.8442C21.0002 19.4462 21.0002 18.972 21.0002 18.0237C21.0002 17.3755 21.0002 17.0514 20.9124 16.7643C20.8023 16.4045 20.5933 16.0829 20.3092 15.8361C20.0826 15.6393 19.7864 15.5076 19.194 15.2443L18.288 14.8417C17.6465 14.5566 17.3257 14.414 16.9998 14.383C16.6878 14.3533 16.3733 14.3971 16.0813 14.5108C15.7762 14.6296 15.5066 14.8543 14.9672 15.3038C14.4304 15.7511 14.162 15.9748 13.834 16.0946C13.5432 16.2009 13.1588 16.2402 12.8526 16.1951C12.5071 16.1442 12.2426 16.0028 11.7135 15.7201C10.0675 14.8404 9.15977 13.9327 8.28011 12.2867C7.99738 11.7576 7.85602 11.4931 7.80511 11.1476C7.75998 10.8414 7.79932 10.457 7.90554 10.1662C8.02536 9.83822 8.24905 9.5698 8.69643 9.03294C9.14586 8.49362 9.37058 8.22396 9.48939 7.91885C9.60309 7.62688 9.64686 7.31234 9.61719 7.00042C9.58618 6.67446 9.44362 6.3537 9.1585 5.71217Z" />
      </svg>
    </>
  );

  return <SwiftIcon color="none" size={size} path={path} />;
}

export function Key({ size, color = '#757575' }) {
  const path = (
    <>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color={color} fill="none" stroke={color} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
        <path d="M15.5 14.5C18.8137 14.5 21.5 11.8137 21.5 8.5C21.5 5.18629 18.8137 2.5 15.5 2.5C12.1863 2.5 9.5 5.18629 9.5 8.5C9.5 9.38041 9.68962 10.2165 10.0303 10.9697L2.5 18.5V21.5H5.5V19.5H7.5V17.5H9.5L13.0303 13.9697C13.7835 14.3104 14.6196 14.5 15.5 14.5Z" />
        <path d="M17.5 6.5L16.5 7.5" />
      </svg>
    </>
  );

  return <SwiftIcon size={size} color={color} path={path} />;
}

export function Sheild({ size, color = '#757575' }) {
  const path = (
    <>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color={color} fill="none" stroke={color} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
        <path d="M18.7088 3.49534C16.8165 2.55382 14.5009 2 12 2C9.4991 2 7.1835 2.55382 5.29116 3.49534C4.36318 3.95706 3.89919 4.18792 3.4496 4.91378C3 5.63965 3 6.34248 3 7.74814V11.2371C3 16.9205 7.54236 20.0804 10.173 21.4338C10.9067 21.8113 11.2735 22 12 22C12.7265 22 13.0933 21.8113 13.8269 21.4338C16.4576 20.0804 21 16.9205 21 11.2371L21 7.74814C21 6.34249 21 5.63966 20.5504 4.91378C20.1008 4.18791 19.6368 3.95706 18.7088 3.49534Z" />
        <path d="M15 11C15 12.6568 13.6569 14 12 14C10.3431 14 9 12.6568 9 11C9 9.34314 10.3431 8 12 8C13.6569 8 15 9.34314 15 11Z" />
      </svg>
    </>
  );

  return <SwiftIcon size={size} color={color} path={path} />;
}

export function Refresh({ color = ICON_COLORS["SWIFT_COLOR1"], size }) {
  const path = (
    <>
      <path
        d="M20.4879 15C19.2524 18.4956 15.9187 21 12 21C7.02943 21 3 16.9706 3 12C3 7.02943 7.02943 3 12 3C15.7292 3 18.9286 5.26806 20.2941 8.5"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 9H18C19.4142 9 20.1213 9 20.5607 8.56066C21 8.12132 21 7.41421 21 6V3"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  );

  return <SwiftIcon size={size} color="none" path={path} viewBox="0 0 24 24" />;
}

export function Success({ color = ICON_COLORS["SWIFT_COLOR1"], size }) {
  const path = (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" stroke={color} fill={color} id="success">
      <path d="M41.78 57.13a7.12 7.12 0 0 1-4.2-1.39l-4.32-3.16a3.12 3.12 0 0 0-3.7 0l-4.32 3.16a7.14 7.14 0 0 1-11.31-6.53l.58-5.32a3.11 3.11 0 0 0-1.85-3.2l-4.89-2.16a7.13 7.13 0 0 1 0-13.06l4.89-2.16a3.11 3.11 0 0 0 1.85-3.2l-.58-5.32a7.14 7.14 0 0 1 11.31-6.53l4.32 3.16a3.12 3.12 0 0 0 3.7 0l4.32-3.16A7 7 0 0 1 43 7a7.25 7.25 0 0 1 4.75 3.13 2 2 0 1 1-3.34 2.2 3.23 3.23 0 0 0-2.12-1.39 3 3 0 0 0-2.37.57l-4.32 3.16a7.13 7.13 0 0 1-8.43 0l-4.31-3.16a3.13 3.13 0 0 0-5 2.87l.58 5.31A7.11 7.11 0 0 1 14.28 27l-4.9 2.16a3.14 3.14 0 0 0 0 5.74l4.9 2.1a7.11 7.11 0 0 1 4.21 7.3l-.58 5.31a3.13 3.13 0 0 0 5 2.87l4.31-3.16a7.13 7.13 0 0 1 8.43 0l4.32 3.16a3.13 3.13 0 0 0 5-2.87l-.58-5.31a7.1 7.1 0 0 1 4.15-7.3l4.9-2.16a3.14 3.14 0 0 0 0-5.74L50.78 28a2 2 0 1 1 1.61-3.66l2.66 1.17a7.13 7.13 0 0 1 0 13.06l-4.89 2.16a3.13 3.13 0 0 0-1.86 3.2l.58 5.32a7 7 0 0 1-3.52 6.95 7.17 7.17 0 0 1-3.58.93Z" fill={color}></path>
      <path d="M31.64 39a2 2 0 0 1-1.42-.59l-8.61-8.61a2 2 0 1 1 2.83-2.8l7.2 7.2L57.08 8.72a2 2 0 0 1 2.82 2.83L33.05 38.4a2 2 0 0 1-1.41.6Z" fill={color}></path>
    </svg>
  );

  return <SwiftIcon size={size} color={color} path={path} />;
}

export function Fail({ color = ICON_COLORS["SWIFT_COLOR1"], size }) {
  const path = (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" stroke={color} fill={color} id="fail">
      <path d="M47.91 53.91a5.93 5.93 0 0 1-4.24-1.76l-4.32-4.32A2 2 0 0 1 42.17 45l4.33 4.32a2 2 0 0 0 2.82 0 2 2 0 0 0 0-2.82L36.24 33.41a2 2 0 0 1 0-2.82L49.32 17.5a2 2 0 0 0 0-2.82 2 2 0 0 0-2.82 0L33.41 27.76a2 2 0 0 1-2.82 0L17.5 14.68a2 2 0 0 0-2.82 0 2 2 0 0 0 0 2.82l13.08 13.09a2 2 0 0 1 0 2.82L14.68 46.5a2 2 0 0 0 0 2.82 2 2 0 0 0 2.82 0l13.09-13.08a2 2 0 0 1 2.82 0l2.44 2.44A2 2 0 0 1 33 41.51l-1-1-11.67 11.64a6 6 0 1 1-8.48-8.48L23.51 32 11.85 20.33a6 6 0 1 1 8.48-8.48L32 23.51l11.67-11.66a6 6 0 1 1 8.48 8.48L40.49 32l11.66 11.67a6 6 0 0 1-4.24 10.24Z" fill={color}></path>
    </svg>
  );

  return <SwiftIcon size={size} color={color} path={path} />;
}